/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class GatewayClientServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * configureApp
     * @param input input
     * @return OK
     */
    configureApp(input: ConfigureAppDto): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/client/configure/app";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processConfigureApp(_response);
        });
    }

    protected processConfigureApp(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * export
     * @param dto dto
     * @return OK
     */
    export(dto: GatewayExportDTO): Promise<ROfListOfGatewayExportVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/client/gateway/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<ROfListOfGatewayExportVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfGatewayExportVO.fromJS(resultData200) : new ROfListOfGatewayExportVO();
            return result200;
        }
        return Promise.resolve<ROfListOfGatewayExportVO>(<any>null);
    }

    /**
     * getGatewayById
     * @param gatewayId gatewayId
     * @return OK
     */
    getGatewayById(gatewayId: string): Promise<ROfGatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/client/gateway/get-gateway-by-id?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayById(_response);
        });
    }

    protected processGetGatewayById(response: AxiosResponse): Promise<ROfGatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfGatewayVO.fromJS(resultData200) : new ROfGatewayVO();
            return result200;
        }
        return Promise.resolve<ROfGatewayVO>(<any>null);
    }

    /**
     * getGateways
     * @param operatorCode operatorCode
     * @return OK
     */
    getGateways(operatorCode: string): Promise<ROfListOfGatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/client/gateway/get-gateways-with-operatorcode?";
        if (operatorCode === undefined || operatorCode === null)
            throw new Error("The parameter 'operatorCode' must be defined and cannot be null.");
        else
            url_ += "operatorCode=" + encodeURIComponent("" + operatorCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGateways(_response);
        });
    }

    protected processGetGateways(response: AxiosResponse): Promise<ROfListOfGatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfGatewayVO.fromJS(resultData200) : new ROfListOfGatewayVO();
            return result200;
        }
        return Promise.resolve<ROfListOfGatewayVO>(<any>null);
    }

    /**
     * getGatewayListByIdList
     * @param gatewayIdList gatewayIdList
     * @return OK
     */
    getGatewayListByIdList(gatewayIdList: string[]): Promise<ROfListOfGatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/client/gateway/getGatewayListByIdList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gatewayIdList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayListByIdList(_response);
        });
    }

    protected processGetGatewayListByIdList(response: AxiosResponse): Promise<ROfListOfGatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfGatewayVO.fromJS(resultData200) : new ROfListOfGatewayVO();
            return result200;
        }
        return Promise.resolve<ROfListOfGatewayVO>(<any>null);
    }

    /**
     * updateCityCode
     * @param cityCode cityCode
     * @param gatewayId gatewayId
     * @return OK
     */
    updateCityCode(cityCode: string, gatewayId: string): Promise<ROfstring> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/client/gateway/update-city-code?";
        if (cityCode === undefined || cityCode === null)
            throw new Error("The parameter 'cityCode' must be defined and cannot be null.");
        else
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&"; 
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateCityCode(_response);
        });
    }

    protected processUpdateCityCode(response: AxiosResponse): Promise<ROfstring> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfstring.fromJS(resultData200) : new ROfstring();
            return result200;
        }
        return Promise.resolve<ROfstring>(<any>null);
    }

    /**
     * updateICCID
     * @param gatewayId gatewayId
     * @param iCCID ICCID
     * @return OK
     */
    updateICCID(gatewayId: string, iCCID: string): Promise<ROfstring> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/client/gateway/update_iccid?";
        if (iCCID === undefined || iCCID === null)
            throw new Error("The parameter 'iCCID' must be defined and cannot be null.");
        else
            url_ += "ICCID=" + encodeURIComponent("" + iCCID) + "&"; 
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateICCID(_response);
        });
    }

    protected processUpdateICCID(response: AxiosResponse): Promise<ROfstring> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfstring.fromJS(resultData200) : new ROfstring();
            return result200;
        }
        return Promise.resolve<ROfstring>(<any>null);
    }

    /**
     * useAppPropertyTemplate
     * @param input input
     * @return OK
     */
    useAppPropertyTemplate(input: UseAppPropertyTemplateDTO): Promise<ROfUseAppPropertyTemplateVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/client/gateway/use-app-property-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUseAppPropertyTemplate(_response);
        });
    }

    protected processUseAppPropertyTemplate(response: AxiosResponse): Promise<ROfUseAppPropertyTemplateVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfUseAppPropertyTemplateVO.fromJS(resultData200) : new ROfUseAppPropertyTemplateVO();
            return result200;
        }
        return Promise.resolve<ROfUseAppPropertyTemplateVO>(<any>null);
    }

    /**
     * getGatewayStates
     * @param gatewayId gatewayId
     * @return OK
     */
    getGatewayStates(gatewayId: string): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/client/get-gateway-states?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayStates(_response);
        });
    }

    protected processGetGatewayStates(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * getGatewayByCode
     * @param gatewayCode gatewayCode
     * @return OK
     */
    getGatewayByCode(gatewayCode: string): Promise<ROfGatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot/get-gateway-by-code?";
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayByCode(_response);
        });
    }

    protected processGetGatewayByCode(response: AxiosResponse): Promise<ROfGatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfGatewayVO.fromJS(resultData200) : new ROfGatewayVO();
            return result200;
        }
        return Promise.resolve<ROfGatewayVO>(<any>null);
    }

    /**
     * getGatewayTypeById
     * @param gatewayId gatewayId
     * @return OK
     */
    getGatewayTypeById(gatewayId: string): Promise<ROfint> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot/get-gateway-type-by-id?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayTypeById(_response);
        });
    }

    protected processGetGatewayTypeById(response: AxiosResponse): Promise<ROfint> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfint.fromJS(resultData200) : new ROfint();
            return result200;
        }
        return Promise.resolve<ROfint>(<any>null);
    }

    /**
     * initIotWorkstationAssociate
     * @param input input
     * @return OK
     */
    initIotWorkstationAssociate(input: UpdateIotWorkstationAssociateDTO[]): Promise<ROfint> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot/init-iot-workstation-associate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInitIotWorkstationAssociate(_response);
        });
    }

    protected processInitIotWorkstationAssociate(response: AxiosResponse): Promise<ROfint> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfint.fromJS(resultData200) : new ROfint();
            return result200;
        }
        return Promise.resolve<ROfint>(<any>null);
    }

    /**
     * updateIotWorkstationAssociate
     * @param input input
     * @return OK
     */
    updateIotWorkstationAssociate(input: UpdateIotWorkstationAssociateDTO): Promise<ROfobject> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot/update-iot-workstation-associate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateIotWorkstationAssociate(_response);
        });
    }

    protected processUpdateIotWorkstationAssociate(response: AxiosResponse): Promise<ROfobject> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfobject.fromJS(resultData200) : new ROfobject();
            return result200;
        }
        return Promise.resolve<ROfobject>(<any>null);
    }
}

export class IotAppClientServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * findAppMethodList
     * @param appCode appCode
     * @param gatewayCode gatewayCode
     * @return OK
     */
    findAppMethodList(appCode: number, gatewayCode: string): Promise<ROfListOfMethodVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/client/iot-app/findAppMethodList?";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined and cannot be null.");
        else
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindAppMethodList(_response);
        });
    }

    protected processFindAppMethodList(response: AxiosResponse): Promise<ROfListOfMethodVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfMethodVO.fromJS(resultData200) : new ROfListOfMethodVO();
            return result200;
        }
        return Promise.resolve<ROfListOfMethodVO>(<any>null);
    }

    /**
     * getIotAppByGatewayAndCodeAppCode
     * @param appCode appCode
     * @param gatewayCode gatewayCode
     * @return OK
     */
    getIotAppByGatewayAndCodeAppCode(appCode: number, gatewayCode: string): Promise<ROfIotAppVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app/get-iot-app-by-gateway-code-app-code?";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined and cannot be null.");
        else
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotAppByGatewayAndCodeAppCode(_response);
        });
    }

    protected processGetIotAppByGatewayAndCodeAppCode(response: AxiosResponse): Promise<ROfIotAppVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIotAppVO.fromJS(resultData200) : new ROfIotAppVO();
            return result200;
        }
        return Promise.resolve<ROfIotAppVO>(<any>null);
    }

    /**
     * listByAppIds
     * @param appIds appIds
     * @return OK
     */
    listByAppIds(appIds: number[]): Promise<ROfListOfIotAppVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app/list-by-app-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appIds);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListByAppIds(_response);
        });
    }

    protected processListByAppIds(response: AxiosResponse): Promise<ROfListOfIotAppVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfIotAppVO.fromJS(resultData200) : new ROfListOfIotAppVO();
            return result200;
        }
        return Promise.resolve<ROfListOfIotAppVO>(<any>null);
    }

    /**
     * queryExtranetAppStatus
     * @param gatewayCodes gatewayCodes
     * @return OK
     */
    queryExtranetAppStatus(gatewayCodes: string[]): Promise<ROfListOfExtranetAppStatusBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app/query-extranet-app-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gatewayCodes);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryExtranetAppStatus(_response);
        });
    }

    protected processQueryExtranetAppStatus(response: AxiosResponse): Promise<ROfListOfExtranetAppStatusBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfExtranetAppStatusBO.fromJS(resultData200) : new ROfListOfExtranetAppStatusBO();
            return result200;
        }
        return Promise.resolve<ROfListOfExtranetAppStatusBO>(<any>null);
    }

    /**
     * listIotAppByGatewayCodes
     * @param gatewayCodeList gatewayCodeList
     * @return OK
     */
    listIotAppByGatewayCodes(gatewayCodeList: string[]): Promise<ROfListOfIotAppBriefBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-applist-iot-app-by-gateway-codes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gatewayCodeList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListIotAppByGatewayCodes(_response);
        });
    }

    protected processListIotAppByGatewayCodes(response: AxiosResponse): Promise<ROfListOfIotAppBriefBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfIotAppBriefBO.fromJS(resultData200) : new ROfListOfIotAppBriefBO();
            return result200;
        }
        return Promise.resolve<ROfListOfIotAppBriefBO>(<any>null);
    }
}

export class IotClientServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * longTimeNoConnection
     * @return OK
     */
    longTimeNoConnection(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/client/long-time-no-connection";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLongTimeNoConnection(_response);
        });
    }

    protected processLongTimeNoConnection(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class DashboardServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取过去一小时内频繁上下线网关前十
     * @return OK
     */
    frequentOnlineGateway(): Promise<ListResultVOOfFrequentOnlineGatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/dashboard/frequent-online-gateway";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFrequentOnlineGateway(_response);
        });
    }

    protected processFrequentOnlineGateway(response: AxiosResponse): Promise<ListResultVOOfFrequentOnlineGatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfFrequentOnlineGatewayVO.fromJS(resultData200) : new ListResultVOOfFrequentOnlineGatewayVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfFrequentOnlineGatewayVO>(<any>null);
    }

    /**
     * 统计每小时异常连接数量
     * @return OK
     */
    getAbnormalConnectionCount(): Promise<StatisticsIotAbnormalConnectionVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/dashboard/get-abnormal-connection-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAbnormalConnectionCount(_response);
        });
    }

    protected processGetAbnormalConnectionCount(response: AxiosResponse): Promise<StatisticsIotAbnormalConnectionVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatisticsIotAbnormalConnectionVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StatisticsIotAbnormalConnectionVO[]>(<any>null);
    }

    /**
     * 分页查询异常连接信息
     * @param pageIndex pageIndex
     * @param pageSize pageSize
     * @return OK
     */
    getAbnormalConnectionList(pageIndex: number, pageSize: number): Promise<PagedResultVOOfIotAbnormalConnectionVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/dashboard/get-abnormal-connection-list?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAbnormalConnectionList(_response);
        });
    }

    protected processGetAbnormalConnectionList(response: AxiosResponse): Promise<PagedResultVOOfIotAbnormalConnectionVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfIotAbnormalConnectionVO.fromJS(resultData200) : new PagedResultVOOfIotAbnormalConnectionVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfIotAbnormalConnectionVO>(<any>null);
    }

    /**
     * 获取异常连接总数
     * @return OK
     */
    getAbnormalConnectionTotal(): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/dashboard/get-abnormal-connection-total";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAbnormalConnectionTotal(_response);
        });
    }

    protected processGetAbnormalConnectionTotal(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 获取仲裁服务运行状态
     * @return OK
     */
    getGatewayStatue(): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/dashboard/get-gateway-statue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayStatue(_response);
        });
    }

    protected processGetGatewayStatue(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取同一个code激活的网关列表
     * @return OK
     */
    getMaybeSomeCodeGateway(): Promise<ListResultVOOfGatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/dashboard/get-maybe-some-code-gateway";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMaybeSomeCodeGateway(_response);
        });
    }

    protected processGetMaybeSomeCodeGateway(response: AxiosResponse): Promise<ListResultVOOfGatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfGatewayVO.fromJS(resultData200) : new ListResultVOOfGatewayVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfGatewayVO>(<any>null);
    }

    /**
     * 获取消息流量前十的连接信息
     * @return OK
     */
    getMessageTopTen(): Promise<ListResultVOOfIotMessageStatisticsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/dashboard/get-message-top-ten";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMessageTopTen(_response);
        });
    }

    protected processGetMessageTopTen(response: AxiosResponse): Promise<ListResultVOOfIotMessageStatisticsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfIotMessageStatisticsVO.fromJS(resultData200) : new ListResultVOOfIotMessageStatisticsVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfIotMessageStatisticsVO>(<any>null);
    }

    /**
     * 服务连接数统计
     * @return OK
     */
    getNodeList(): Promise<ListResultVOOfIotModelNode> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/dashboard/get-node-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetNodeList(_response);
        });
    }

    protected processGetNodeList(response: AxiosResponse): Promise<ListResultVOOfIotModelNode> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfIotModelNode.fromJS(resultData200) : new ListResultVOOfIotModelNode();
            return result200;
        }
        return Promise.resolve<ListResultVOOfIotModelNode>(<any>null);
    }

    /**
     * 获取NotPackageException导致的异常连接
     * @return OK
     */
    getNotPackageException(): Promise<IotAbnormalConnectionVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/dashboard/get-not-package-exception";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetNotPackageException(_response);
        });
    }

    protected processGetNotPackageException(response: AxiosResponse): Promise<IotAbnormalConnectionVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IotAbnormalConnectionVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<IotAbnormalConnectionVO[]>(<any>null);
    }

    /**
     * 网关连接状态统计
     * @return OK
     */
    statisticsGateway(): Promise<StatisticsGatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/dashboard/statistics-gateway";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStatisticsGateway(_response);
        });
    }

    protected processStatisticsGateway(response: AxiosResponse): Promise<StatisticsGatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StatisticsGatewayVO.fromJS(resultData200) : new StatisticsGatewayVO();
            return result200;
        }
        return Promise.resolve<StatisticsGatewayVO>(<any>null);
    }
}

export class FirmwareServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 批量删除固件
     * @param inDTO inDTO
     * @return OK
     */
    deleteFirmwares(inDTO: DeleteFirmwareDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/firmware/delete-firmwares";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteFirmwares(_response);
        });
    }

    protected processDeleteFirmwares(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 根据主键查询固件信息
     * @param id id
     * @return OK
     */
    getFirmwareById(id: string): Promise<FirmwareVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/firmware/get-firmware-by-id?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFirmwareById(_response);
        });
    }

    protected processGetFirmwareById(response: AxiosResponse): Promise<FirmwareVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FirmwareVO.fromJS(resultData200) : new FirmwareVO();
            return result200;
        }
        return Promise.resolve<FirmwareVO>(<any>null);
    }

    /**
     * findFirmwareByIssue
     * @param issueId issueId
     * @return OK
     */
    findFirmwareByIssue(issueId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/firmware/get-firmware-by-issue-id?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindFirmwareByIssue(_response);
        });
    }

    protected processFindFirmwareByIssue(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 查询单个固件发行动作及结果
     * @param issueId issueId
     * @return OK
     */
    getFirmwareLog(issueId: string): Promise<FirmwareIssueLogVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/firmware/get-firmware-log?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFirmwareLog(_response);
        });
    }

    protected processGetFirmwareLog(response: AxiosResponse): Promise<FirmwareIssueLogVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FirmwareIssueLogVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<FirmwareIssueLogVO[]>(<any>null);
    }

    /**
     * 发行固件
     * @param dto dto
     * @return OK
     */
    issueFirmware(dto: IssueFirmwareDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/firmware/issue-firmware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processIssueFirmware(_response);
        });
    }

    protected processIssueFirmware(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询固件信息
     * @param dto dto
     * @return OK
     */
    pageFirmware(dto: PageFirmwareDTO): Promise<PagedResultVOOfFirmwareVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/firmware/page-firmware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageFirmware(_response);
        });
    }

    protected processPageFirmware(response: AxiosResponse): Promise<PagedResultVOOfFirmwareVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfFirmwareVO.fromJS(resultData200) : new PagedResultVOOfFirmwareVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfFirmwareVO>(<any>null);
    }

    /**
     * 分页查询固件发行结果
     * @param dto dto
     * @return OK
     */
    pageFirmwareLog(dto: PageFirmwareLogDTO): Promise<PagedResultVOOfFirmwareIssueResultVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/firmware/page-firmware-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageFirmwareLog(_response);
        });
    }

    protected processPageFirmwareLog(response: AxiosResponse): Promise<PagedResultVOOfFirmwareIssueResultVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfFirmwareIssueResultVO.fromJS(resultData200) : new PagedResultVOOfFirmwareIssueResultVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfFirmwareIssueResultVO>(<any>null);
    }

    /**
     * 添加固件发行日志
     * @param action action
     * @param actionEnd actionEnd
     * @param actionTime actionTime
     * @param gatewayCode gatewayCode
     * @param issueId issueId
     * @param message message
     * @return OK
     */
    reportFirmwareLog(action: number, actionEnd: number, actionTime: string, gatewayCode: string, issueId: string, message: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/firmware/report-firmware-log?";
        if (action === undefined || action === null)
            throw new Error("The parameter 'action' must be defined and cannot be null.");
        else
            url_ += "action=" + encodeURIComponent("" + action) + "&"; 
        if (actionEnd === undefined || actionEnd === null)
            throw new Error("The parameter 'actionEnd' must be defined and cannot be null.");
        else
            url_ += "actionEnd=" + encodeURIComponent("" + actionEnd) + "&"; 
        if (actionTime === undefined || actionTime === null)
            throw new Error("The parameter 'actionTime' must be defined and cannot be null.");
        else
            url_ += "actionTime=" + encodeURIComponent("" + actionTime) + "&"; 
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (message === undefined || message === null)
            throw new Error("The parameter 'message' must be defined and cannot be null.");
        else
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReportFirmwareLog(_response);
        });
    }

    protected processReportFirmwareLog(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 更新固件
     * @param dto dto
     * @return OK
     */
    updateFirmware(dto: UpdateFirmwareDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/firmware/update-firmware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateFirmware(_response);
        });
    }

    protected processUpdateFirmware(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 上传固件
     * @param dto dto
     * @return OK
     */
    uploadFirmware(dto: UploadFirmwareDTO): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/firmware/upload-firmware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUploadFirmware(_response);
        });
    }

    protected processUploadFirmware(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class GatewaySimServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getGatewayIccid
     * @param gatewayId gatewayId
     * @return OK
     */
    getGatewayIccid(gatewayId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway-sim/getGatewayIccid?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayIccid(_response);
        });
    }

    protected processGetGatewayIccid(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * getGatewayImei
     * @param gatewayId gatewayId
     * @return OK
     */
    getGatewayImei(gatewayId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway-sim/getGatewayImei?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayImei(_response);
        });
    }

    protected processGetGatewayImei(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * getGatewayImsi
     * @param gatewayId gatewayId
     * @return OK
     */
    getGatewayImsi(gatewayId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway-sim/getGatewayImsi?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayImsi(_response);
        });
    }

    protected processGetGatewayImsi(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * getGatewayRssi
     * @param gatewayId gatewayId
     * @return OK
     */
    getGatewayRssi(gatewayId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway-sim/getGatewayRssi?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayRssi(_response);
        });
    }

    protected processGetGatewayRssi(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * refreshGatewayIccid
     * @param gatewayId gatewayId
     * @return OK
     */
    refreshGatewayIccid(gatewayId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway-sim/refreshGatewayIccid?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRefreshGatewayIccid(_response);
        });
    }

    protected processRefreshGatewayIccid(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * refreshGatewayImei
     * @param gatewayId gatewayId
     * @return OK
     */
    refreshGatewayImei(gatewayId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway-sim/refreshGatewayImei?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRefreshGatewayImei(_response);
        });
    }

    protected processRefreshGatewayImei(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * refreshGatewayImsi
     * @param gatewayId gatewayId
     * @return OK
     */
    refreshGatewayImsi(gatewayId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway-sim/refreshGatewayImsi?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRefreshGatewayImsi(_response);
        });
    }

    protected processRefreshGatewayImsi(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * refreshGatewayRssi
     * @param gatewayId gatewayId
     * @return OK
     */
    refreshGatewayRssi(gatewayId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway-sim/refreshGatewayRssi?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRefreshGatewayRssi(_response);
        });
    }

    protected processRefreshGatewayRssi(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class GatewayTenantClientServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getGatewayByTenantId
     * @param tenantId tenantId
     * @return OK
     */
    getGatewayByTenantId(tenantId: string): Promise<ROfListOfGatewayBriefBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway-tenant/get-gateway-by-tenant-id?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined and cannot be null.");
        else
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayByTenantId(_response);
        });
    }

    protected processGetGatewayByTenantId(response: AxiosResponse): Promise<ROfListOfGatewayBriefBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfGatewayBriefBO.fromJS(resultData200) : new ROfListOfGatewayBriefBO();
            return result200;
        }
        return Promise.resolve<ROfListOfGatewayBriefBO>(<any>null);
    }

    /**
     * getTenantIdListByGateway
     * @param gatewayId gatewayId
     * @return OK
     */
    getTenantIdListByGateway(gatewayId: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway-tenant/get_tenant_list_by_gateway?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTenantIdListByGateway(_response);
        });
    }

    protected processGetTenantIdListByGateway(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * linkGatewayTenant
     * @param linkGatewayTenantDto linkGatewayTenantDto
     * @return OK
     */
    linkGatewayTenant(linkGatewayTenantDto: LinkGatewayTenantDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway-tenant/link_gateway_tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(linkGatewayTenantDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLinkGatewayTenant(_response);
        });
    }

    protected processLinkGatewayTenant(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * unLinkGatewayTenant
     * @param linkGatewayTenantDto linkGatewayTenantDto
     * @return OK
     */
    unLinkGatewayTenant(linkGatewayTenantDto: LinkGatewayTenantDTO): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway-tenant/unlink_gateway_tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(linkGatewayTenantDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUnLinkGatewayTenant(_response);
        });
    }

    protected processUnLinkGatewayTenant(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class GatewayServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出网关授权信息
     * @param gatewayId (optional) 网关主键
     * @return OK
     */
    exportGatewayAuthentication(gatewayId: string | null | undefined): Promise<AuthenticationVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/export-gateway-authorization?";
        if (gatewayId !== undefined)
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportGatewayAuthentication(_response);
        });
    }

    protected processExportGatewayAuthentication(response: AxiosResponse): Promise<AuthenticationVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AuthenticationVO.fromJS(resultData200) : new AuthenticationVO();
            return result200;
        }
        return Promise.resolve<AuthenticationVO>(<any>null);
    }

    /**
     * 获取可分配的网关列表
     * @return OK
     */
    findAssignableGatewayList(): Promise<ListResultVOOfGatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/find-assignable-gateway-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindAssignableGatewayList(_response);
        });
    }

    protected processFindAssignableGatewayList(response: AxiosResponse): Promise<ListResultVOOfGatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfGatewayVO.fromJS(resultData200) : new ListResultVOOfGatewayVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfGatewayVO>(<any>null);
    }

    /**
     * 分页查询网关信息
     * @param dto dto
     * @return OK
     */
    findGatewayList(dto: PageGatewayDTO): Promise<PagedResultVOOfGatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/find-gateway-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindGatewayList(_response);
        });
    }

    protected processFindGatewayList(response: AxiosResponse): Promise<PagedResultVOOfGatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfGatewayVO.fromJS(resultData200) : new PagedResultVOOfGatewayVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfGatewayVO>(<any>null);
    }

    /**
     * 网关租户迁移
     * @param gatewayTransferDTO gatewayTransferDTO
     * @return OK
     */
    gatewayTransfer(gatewayTransferDTO: GatewayTransferDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/gateway-transfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gatewayTransferDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGatewayTransfer(_response);
        });
    }

    protected processGatewayTransfer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 根据code获取网关信息
     * @param code code
     * @return OK
     */
    getGatewayByCode(code: string): Promise<GatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/get-gateway-by-code?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayByCode(_response);
        });
    }

    protected processGetGatewayByCode(response: AxiosResponse): Promise<GatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? GatewayVO.fromJS(resultData200) : new GatewayVO();
            return result200;
        }
        return Promise.resolve<GatewayVO>(<any>null);
    }

    /**
     * 根据主键id获取网关信息
     * @param id id
     * @return OK
     */
    getGatewayById(id: string): Promise<GatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/get-gateway-by-id?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayById(_response);
        });
    }

    protected processGetGatewayById(response: AxiosResponse): Promise<GatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? GatewayVO.fromJS(resultData200) : new GatewayVO();
            return result200;
        }
        return Promise.resolve<GatewayVO>(<any>null);
    }

    /**
     * getGatewayIccid
     * @param gatewayId gatewayId
     * @return OK
     */
    getGatewayIccid(gatewayId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/get-gateway-iccid?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayIccid(_response);
        });
    }

    protected processGetGatewayIccid(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * getGatewayTypeById
     * @param gatewayId gatewayId
     * @return OK
     */
    getGatewayTypeById(gatewayId: string): Promise<ROfint> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/get-gateway-type-by-id?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayTypeById(_response);
        });
    }

    protected processGetGatewayTypeById(response: AxiosResponse): Promise<ROfint> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfint.fromJS(resultData200) : new ROfint();
            return result200;
        }
        return Promise.resolve<ROfint>(<any>null);
    }

    /**
     * initTempWhitelist
     * @param end end
     * @param start start
     * @param timeout (optional) timeout
     * @return OK
     */
    initTempWhitelist(end: string, start: string, timeout: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/init/temp/whitelist?";
        if (end === undefined || end === null)
            throw new Error("The parameter 'end' must be defined and cannot be null.");
        else
            url_ += "end=" + encodeURIComponent("" + end) + "&"; 
        if (start === undefined || start === null)
            throw new Error("The parameter 'start' must be defined and cannot be null.");
        else
            url_ += "start=" + encodeURIComponent("" + start) + "&"; 
        if (timeout !== undefined)
            url_ += "timeout=" + encodeURIComponent("" + timeout) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInitTempWhitelist(_response);
        });
    }

    protected processInitTempWhitelist(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * initWhitelist
     * @return OK
     */
    initWhitelist(): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/init/whitelist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInitWhitelist(_response);
        });
    }

    protected processInitWhitelist(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * iotServerStop
     * @param serverStopDTO serverStopDTO
     * @return OK
     */
    iotServerStop(serverStopDTO: ServerStopDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/iot-server-stop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serverStopDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processIotServerStop(_response);
        });
    }

    protected processIotServerStop(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * pageNotOnlineGateway
     * @param inDTO inDTO
     * @return OK
     */
    pageNotOnlineGateway(inDTO: NotOnlineGatewayDTO): Promise<PagedResultVOOfGatewayBriefVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/page-not-online-gateway";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageNotOnlineGateway(_response);
        });
    }

    protected processPageNotOnlineGateway(response: AxiosResponse): Promise<PagedResultVOOfGatewayBriefVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfGatewayBriefVO.fromJS(resultData200) : new PagedResultVOOfGatewayBriefVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfGatewayBriefVO>(<any>null);
    }

    /**
     * 回收网关
     * @param inDTO inDTO
     * @return OK
     */
    recycleGateway(inDTO: RecycleGatewayDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/recycle-gateway";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRecycleGateway(_response);
        });
    }

    protected processRecycleGateway(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * refreshGatewayIccid
     * @param gatewayId gatewayId
     * @return OK
     */
    refreshGatewayIccid(gatewayId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/refresh-gateway-iccid?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRefreshGatewayIccid(_response);
        });
    }

    protected processRefreshGatewayIccid(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 登记网关
     * @param dto dto
     * @return OK
     */
    registerGateway(dto: RegisterGatewayDTO): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/register-gateway";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRegisterGateway(_response);
        });
    }

    protected processRegisterGateway(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 修改网关描述
     * @param dto dto
     * @return OK
     */
    updateGateway(dto: UpdateGatewayDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/gateway/update-gateway";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateGateway(_response);
        });
    }

    protected processUpdateGateway(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class HubServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加hub
     * @param inDTO inDTO
     * @return OK
     */
    addHub(inDTO: AddHubDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/hub/add-hub";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddHub(_response);
        });
    }

    protected processAddHub(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 删除hub信息
     * @param id (optional) hub主键
     * @return OK
     */
    deleteHub(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/hub/delete-hub?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteHub(_response);
        });
    }

    protected processDeleteHub(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取hub列表
     * @return OK
     */
    getHubList(): Promise<ListResultVOOfHubVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/hub/get-hub-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetHubList(_response);
        });
    }

    protected processGetHubList(response: AxiosResponse): Promise<ListResultVOOfHubVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfHubVO.fromJS(resultData200) : new ListResultVOOfHubVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfHubVO>(<any>null);
    }

    /**
     * 修改hub信息
     * @param inDTO inDTO
     * @return OK
     */
    updateHub(inDTO: UpdateHubDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/hub/update-hub";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateHub(_response);
        });
    }

    protected processUpdateHub(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class IotAppEventServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询网关应用事件列表
     * @param appCode (optional) 网关应用编号
     * @param gatewayCode (optional) 网关SN
     * @return OK
     */
    getIotAppEventList(appCode: number | null | undefined, gatewayCode: string | null | undefined): Promise<ListResultVOOfEventVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-event/get-iot-app-event-list?";
        if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotAppEventList(_response);
        });
    }

    protected processGetIotAppEventList(response: AxiosResponse): Promise<ListResultVOOfEventVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfEventVO.fromJS(resultData200) : new ListResultVOOfEventVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfEventVO>(<any>null);
    }

    /**
     * requestIotEventMetadata
     * @param input input
     * @return OK
     */
    requestIotEventMetadata(input: RequestMetadataDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-event/request-iot-event-metadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRequestIotEventMetadata(_response);
        });
    }

    protected processRequestIotEventMetadata(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class IotAppMethodServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 执行方法
     * @param inDTO inDTO
     * @return OK
     */
    execMethod(inDTO: ExecMethodDTO): Promise<ExecResultVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-method/exec-method";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExecMethod(_response);
        });
    }

    protected processExecMethod(response: AxiosResponse): Promise<ExecResultVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ExecResultVO.fromJS(resultData200) : new ExecResultVO();
            return result200;
        }
        return Promise.resolve<ExecResultVO>(<any>null);
    }

    /**
     * 查询网关应用方法列表
     * @param appCode (optional) 网关应用编号
     * @param gatewayCode (optional) 网关SN
     * @return OK
     */
    getIotAppMethodList(appCode: number | null | undefined, gatewayCode: string | null | undefined): Promise<ListResultVOOfMethodVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-method/get-iot-app-method-list?";
        if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotAppMethodList(_response);
        });
    }

    protected processGetIotAppMethodList(response: AxiosResponse): Promise<ListResultVOOfMethodVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfMethodVO.fromJS(resultData200) : new ListResultVOOfMethodVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfMethodVO>(<any>null);
    }

    /**
     * getMethodParamList
     * @param inDTO inDTO
     * @return OK
     */
    getMethodParamList(inDTO: MethodParamDTO): Promise<ListResultVOOfMethodParamVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-method/get-method-param-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMethodParamList(_response);
        });
    }

    protected processGetMethodParamList(response: AxiosResponse): Promise<ListResultVOOfMethodParamVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfMethodParamVO.fromJS(resultData200) : new ListResultVOOfMethodParamVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfMethodParamVO>(<any>null);
    }

    /**
     * requestIotMethodMetadata
     * @param input input
     * @return OK
     */
    requestIotMethodMetadata(input: RequestMetadataDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-method/request-iot-method-metadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRequestIotMethodMetadata(_response);
        });
    }

    protected processRequestIotMethodMetadata(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class IotAppModelTemplateServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除模板
     * @param inDTO inDTO
     * @return OK
     */
    deleteTemplate(inDTO: DeleteTemplateDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-model-template/delete-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteTemplate(_response);
        });
    }

    protected processDeleteTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 配置模板
     * @param inDTO inDTO
     * @return OK
     */
    deployModelTemplate(inDTO: DeployModelTemplateDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-model-template/deploy-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeployModelTemplate(_response);
        });
    }

    protected processDeployModelTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出模板的Json文件
     * @param templateId (optional) 模板主键id
     * @return OK
     */
    exportTemplateJson(templateId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-model-template/export-template-json?";
        if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportTemplateJson(_response);
        });
    }

    protected processExportTemplateJson(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出IotApp配置为模板
     * @param inDTO inDTO
     * @return OK
     */
    generateModelTemplate(inDTO: ExportAsTemplateDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-model-template/generate-model-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGenerateModelTemplate(_response);
        });
    }

    protected processGenerateModelTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取网关驱动类型
     * @param gatewayCode (optional) 网关SN
     * @return OK
     */
    getDriverType(gatewayCode: string | null | undefined): Promise<ListResultVOOfstring> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-model-template/get-driver-type?";
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDriverType(_response);
        });
    }

    protected processGetDriverType(response: AxiosResponse): Promise<ListResultVOOfstring> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfstring.fromJS(resultData200) : new ListResultVOOfstring();
            return result200;
        }
        return Promise.resolve<ListResultVOOfstring>(<any>null);
    }

    /**
     * 获取模板简要信息
     * @return OK
     */
    getModelTemplateList(): Promise<ListResultVOOfModelTemplateBriefVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-model-template/get-model-template-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetModelTemplateList(_response);
        });
    }

    protected processGetModelTemplateList(response: AxiosResponse): Promise<ListResultVOOfModelTemplateBriefVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfModelTemplateBriefVO.fromJS(resultData200) : new ListResultVOOfModelTemplateBriefVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfModelTemplateBriefVO>(<any>null);
    }

    /**
     * 获取模板详情信息
     * @param templateId (optional) 模板主键
     * @return OK
     */
    getTemplateDetail(templateId: string | null | undefined): Promise<ModelTemplateDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-model-template/get-template-detail?";
        if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTemplateDetail(_response);
        });
    }

    protected processGetTemplateDetail(response: AxiosResponse): Promise<ModelTemplateDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelTemplateDetailVO.fromJS(resultData200) : new ModelTemplateDetailVO();
            return result200;
        }
        return Promise.resolve<ModelTemplateDetailVO>(<any>null);
    }

    /**
     * 导入Json生成模板
     * @param templateFile (optional) 模板Json文件
     * @return OK
     */
    importTemplateJson(templateFile: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-model-template/import-template-json";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (templateFile !== null && templateFile !== undefined)
            content_.append("templateFile", templateFile.data, templateFile.fileName ? templateFile.fileName : "templateFile");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportTemplateJson(_response);
        });
    }

    protected processImportTemplateJson(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询模板信息
     * @param inDTO inDTO
     * @return OK
     */
    pageModelTemplate(inDTO: PageRequestDTO): Promise<PagedResultVOOfModelTemplateDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-model-template/page-model-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageModelTemplate(_response);
        });
    }

    protected processPageModelTemplate(response: AxiosResponse): Promise<PagedResultVOOfModelTemplateDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfModelTemplateDetailVO.fromJS(resultData200) : new PagedResultVOOfModelTemplateDetailVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfModelTemplateDetailVO>(<any>null);
    }

    /**
     * 更新模板信息
     * @param inDTO inDTO
     * @return OK
     */
    updateTemplate(inDTO: UpdateTemplateDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-model-template/update-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateTemplate(_response);
        });
    }

    protected processUpdateTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class IotAppPropertyServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增属性
     * @param inDTO inDTO
     * @return OK
     */
    addIotAppProperty(inDTO: AddIotAppPropertyDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/add-iot-app-property";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddIotAppProperty(_response);
        });
    }

    protected processAddIotAppProperty(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 批量删除属性
     * @param inDTO inDTO
     * @return OK
     */
    deleteIotAppProperty(inDTO: DeleteIotAppPropertyDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/delete-iot-app-property";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteIotAppProperty(_response);
        });
    }

    protected processDeleteIotAppProperty(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出属性配置
     * @param iotAppId iotAppId
     * @return OK
     */
    exportProperties(iotAppId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/export-properties?";
        if (iotAppId === undefined || iotAppId === null)
            throw new Error("The parameter 'iotAppId' must be defined and cannot be null.");
        else
            url_ += "iotAppId=" + encodeURIComponent("" + iotAppId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProperties(_response);
        });
    }

    protected processExportProperties(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * getAppPropertyById
     * @param id (optional) id
     * @return OK
     */
    getAppPropertyById(id: string | null | undefined): Promise<PropertyVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/get-app-property-by-id?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAppPropertyById(_response);
        });
    }

    protected processGetAppPropertyById(response: AxiosResponse): Promise<PropertyVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PropertyVO.fromJS(resultData200) : new PropertyVO();
            return result200;
        }
        return Promise.resolve<PropertyVO>(<any>null);
    }

    /**
     * getIoAddressList
     * @param appCode (optional) 网关应用编号
     * @param gatewayCode (optional) 网关SN
     * @return OK
     */
    getIoAddressList(appCode: number | null | undefined, gatewayCode: string | null | undefined): Promise<ListResultVOOfIoAddressVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/get-ioaddress-list?";
        if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIoAddressList(_response);
        });
    }

    protected processGetIoAddressList(response: AxiosResponse): Promise<ListResultVOOfIoAddressVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfIoAddressVO.fromJS(resultData200) : new ListResultVOOfIoAddressVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfIoAddressVO>(<any>null);
    }

    /**
     * 查询网关应用属性列表
     * @param appCode (optional) 网关应用编号
     * @param gatewayCode (optional) 网关SN
     * @return OK
     */
    getIotAppPropertyList(appCode: number | null | undefined, gatewayCode: string | null | undefined): Promise<ListResultVOOfPropertyListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/get-iot-app-property-list?";
        if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotAppPropertyList(_response);
        });
    }

    protected processGetIotAppPropertyList(response: AxiosResponse): Promise<ListResultVOOfPropertyListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfPropertyListVO.fromJS(resultData200) : new ListResultVOOfPropertyListVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfPropertyListVO>(<any>null);
    }

    /**
     * 查询网关应用属性列表
     * @param appCode (optional) 网关应用编号
     * @param gatewayCode (optional) 网关SN
     * @return OK
     */
    getIotAppPropertyListWithNoValue(appCode: number | null | undefined, gatewayCode: string | null | undefined): Promise<ListResultVOOfPropertyListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/get-iot-app-property-list-with-no-value?";
        if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotAppPropertyListWithNoValue(_response);
        });
    }

    protected processGetIotAppPropertyListWithNoValue(response: AxiosResponse): Promise<ListResultVOOfPropertyListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfPropertyListVO.fromJS(resultData200) : new ListResultVOOfPropertyListVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfPropertyListVO>(<any>null);
    }

    /**
     * getIotAppPropertyPageList
     * @param dto dto
     * @return OK
     */
    getIotAppPropertyPageList(dto: GetIotAppPropertyPageListDTO): Promise<PagedResultVOOfPropertyListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/get-iot-app-property-page-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotAppPropertyPageList(_response);
        });
    }

    protected processGetIotAppPropertyPageList(response: AxiosResponse): Promise<PagedResultVOOfPropertyListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfPropertyListVO.fromJS(resultData200) : new PagedResultVOOfPropertyListVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfPropertyListVO>(<any>null);
    }

    /**
     * getTakeEffectPropertyList
     * @param appCode (optional) 网关应用编号
     * @param gatewayCode (optional) 网关SN
     * @return OK
     */
    getTakeEffectPropertyList(appCode: number | null | undefined, gatewayCode: string | null | undefined): Promise<ListResultVOOfPropertyVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/get-take-effect-property-list?";
        if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTakeEffectPropertyList(_response);
        });
    }

    protected processGetTakeEffectPropertyList(response: AxiosResponse): Promise<ListResultVOOfPropertyVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfPropertyVO.fromJS(resultData200) : new ListResultVOOfPropertyVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfPropertyVO>(<any>null);
    }

    /**
     * 导入属性配置
     * @param file file
     * @param iotAppId iotAppId
     * @return OK
     */
    importProperties(file: FileParameter, iotAppId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/import-properties?";
        if (iotAppId === undefined || iotAppId === null)
            throw new Error("The parameter 'iotAppId' must be defined and cannot be null.");
        else
            url_ += "iotAppId=" + encodeURIComponent("" + iotAppId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportProperties(_response);
        });
    }

    protected processImportProperties(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * readPropertyValue
     * @param input input
     * @return OK
     */
    readPropertyValue(input: ReadPropertyValueDTO): Promise<ListResultVOOfReadPropertyValueVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/read-property-value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReadPropertyValue(_response);
        });
    }

    protected processReadPropertyValue(response: AxiosResponse): Promise<ListResultVOOfReadPropertyValueVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfReadPropertyValueVO.fromJS(resultData200) : new ListResultVOOfReadPropertyValueVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfReadPropertyValueVO>(<any>null);
    }

    /**
     * requestIotPropertyMetadata
     * @param input input
     * @return OK
     */
    requestIotPropertyMetadata(input: RequestMetadataDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/request-iot-property-metadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRequestIotPropertyMetadata(_response);
        });
    }

    protected processRequestIotPropertyMetadata(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 提交属性修改
     * @param appCode (optional) 网关应用编号
     * @param gatewayCode (optional) 网关SN
     * @return OK
     */
    submitProperty(appCode: number | null | undefined, gatewayCode: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/submit-property?";
        if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmitProperty(_response);
        });
    }

    protected processSubmitProperty(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 更新属性
     * @param inDTO inDTO
     * @return OK
     */
    updateIotAppProperty(inDTO: UpdateIotAppPropertyDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/update-iot-app-property";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateIotAppProperty(_response);
        });
    }

    protected processUpdateIotAppProperty(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * writePropertyValue
     * @param input input
     * @return OK
     */
    writePropertyValue(input: WritePropertyValueDTO): Promise<WritePropertyValueResponseVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-property/write-property-value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWritePropertyValue(_response);
        });
    }

    protected processWritePropertyValue(response: AxiosResponse): Promise<WritePropertyValueResponseVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WritePropertyValueResponseVO.fromJS(resultData200) : new WritePropertyValueResponseVO();
            return result200;
        }
        return Promise.resolve<WritePropertyValueResponseVO>(<any>null);
    }
}

export class IotAppSettingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询网关应用设置列表
     * @param appCode (optional) 网关应用编号
     * @param gatewayCode (optional) 网关SN
     * @return OK
     */
    getIotAppSettingList(appCode: number | null | undefined, gatewayCode: string | null | undefined): Promise<ListResultVOOfSettingVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-setting/get-iot-app-setting-list?";
        if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotAppSettingList(_response);
        });
    }

    protected processGetIotAppSettingList(response: AxiosResponse): Promise<ListResultVOOfSettingVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfSettingVO.fromJS(resultData200) : new ListResultVOOfSettingVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfSettingVO>(<any>null);
    }

    /**
     * requestIotSettingMetadata
     * @param input input
     * @return OK
     */
    requestIotSettingMetadata(input: RequestMetadataDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-setting/request-iot-setting-metadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRequestIotSettingMetadata(_response);
        });
    }

    protected processRequestIotSettingMetadata(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 修改网关应用设置
     * @param input input
     * @return OK
     */
    saveIotAppSetting(input: SaveIotAppSettingDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app-setting/save-iot-app-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveIotAppSetting(_response);
        });
    }

    protected processSaveIotAppSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class IotAppServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getIotApp
     * @param appCode appCode
     * @param gatewayCode gatewayCode
     * @return OK
     */
    getIotApp(appCode: number, gatewayCode: string): Promise<IotAppVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app/get-iot-app?";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined and cannot be null.");
        else
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotApp(_response);
        });
    }

    protected processGetIotApp(response: AxiosResponse): Promise<IotAppVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IotAppVO.fromJS(resultData200) : new IotAppVO();
            return result200;
        }
        return Promise.resolve<IotAppVO>(<any>null);
    }

    /**
     * 查询网关所属应用列表
     * @param filter (optional) 关键字
     * @param gatewayCode (optional) 网关编号
     * @param isOnline (optional) 是否在线
     * @return OK
     */
    getIotAppList(filter: string | null | undefined, gatewayCode: string | null | undefined, isOnline: boolean | null | undefined): Promise<ListResultVOOfIotAppVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app/get-iot-app-list?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        if (isOnline !== undefined)
            url_ += "isOnline=" + encodeURIComponent("" + isOnline) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotAppList(_response);
        });
    }

    protected processGetIotAppList(response: AxiosResponse): Promise<ListResultVOOfIotAppVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfIotAppVO.fromJS(resultData200) : new ListResultVOOfIotAppVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfIotAppVO>(<any>null);
    }

    /**
     * monitorLog
     * @param input (optional) APP监听日志
     * @return OK
     */
    monitorLog(input: AppMonitorLogDto | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app/monitor-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMonitorLog(_response);
        });
    }

    protected processMonitorLog(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询网关应用历史通讯记录
     * @param inDTO inDTO
     * @return OK
     */
    pageIotAppCommunicationHistory(inDTO: PageIotAppCommunicationHistoryDTO): Promise<PagedResultVOOfCommunicationInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app/page-iot-app-communication-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageIotAppCommunicationHistory(_response);
        });
    }

    protected processPageIotAppCommunicationHistory(response: AxiosResponse): Promise<PagedResultVOOfCommunicationInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfCommunicationInfoVO.fromJS(resultData200) : new PagedResultVOOfCommunicationInfoVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfCommunicationInfoVO>(<any>null);
    }

    /**
     * startIotApp
     * @param gatewayCode (optional) 网关SN
     * @param targetAppCode (optional) 目标app编号
     * @return OK
     */
    startIotApp(gatewayCode: string | null | undefined, targetAppCode: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app/start-iot-app?";
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        if (targetAppCode !== undefined)
            url_ += "targetAppCode=" + encodeURIComponent("" + targetAppCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStartIotApp(_response);
        });
    }

    protected processStartIotApp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * stopIotApp
     * @param gatewayCode (optional) 网关SN
     * @param targetAppCode (optional) 目标app编号
     * @return OK
     */
    stopIotApp(gatewayCode: string | null | undefined, targetAppCode: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-app/stop-iot-app?";
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        if (targetAppCode !== undefined)
            url_ += "targetAppCode=" + encodeURIComponent("" + targetAppCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStopIotApp(_response);
        });
    }

    protected processStopIotApp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class IotAppPropertyClientServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * filterComplexType
     * @param propertyIdList propertyIdList
     * @return OK
     */
    filterComplexType(propertyIdList: number[]): Promise<ROfSetOflong> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-property/filter-complex-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(propertyIdList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFilterComplexType(_response);
        });
    }

    protected processFilterComplexType(response: AxiosResponse): Promise<ROfSetOflong> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfSetOflong.fromJS(resultData200) : new ROfSetOflong();
            return result200;
        }
        return Promise.resolve<ROfSetOflong>(<any>null);
    }

    /**
     * getIotAppPropertyList
     * @param appCode (optional) 网关应用编号
     * @param gatewayCode (optional) 网关SN
     * @return OK
     */
    getIotAppPropertyList(appCode: number | null | undefined, gatewayCode: string | null | undefined): Promise<ROfListOfPropertyVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-property/get-iot-app-property-list?";
        if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode !== undefined)
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotAppPropertyList(_response);
        });
    }

    protected processGetIotAppPropertyList(response: AxiosResponse): Promise<ROfListOfPropertyVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfPropertyVO.fromJS(resultData200) : new ROfListOfPropertyVO();
            return result200;
        }
        return Promise.resolve<ROfListOfPropertyVO>(<any>null);
    }

    /**
     * getPropertyHistoryData
     * @param inDTO inDTO
     * @return OK
     */
    getPropertyHistoryData(inDTO: PropertyDataDTO): Promise<ROfListOfPropertyDataBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-property/get-property-history-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPropertyHistoryData(_response);
        });
    }

    protected processGetPropertyHistoryData(response: AxiosResponse): Promise<ROfListOfPropertyDataBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfPropertyDataBO.fromJS(resultData200) : new ROfListOfPropertyDataBO();
            return result200;
        }
        return Promise.resolve<ROfListOfPropertyDataBO>(<any>null);
    }

    /**
     * getPropertyLatestData
     * @param input input
     * @return OK
     */
    getPropertyLatestData(input: LatestPropertyDataDTO[]): Promise<ROfListOfPropertyLatestDataBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-property/get-property-latest-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPropertyLatestData(_response);
        });
    }

    protected processGetPropertyLatestData(response: AxiosResponse): Promise<ROfListOfPropertyLatestDataBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfPropertyLatestDataBO.fromJS(resultData200) : new ROfListOfPropertyLatestDataBO();
            return result200;
        }
        return Promise.resolve<ROfListOfPropertyLatestDataBO>(<any>null);
    }
}

export class IotStatisticServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * gatewayStatusRecord
     * @param customerId (optional) 
     * @param recordType (optional) 
     * @return OK
     */
    gatewayStatusRecord(customerId: string | null | undefined, recordType: string | null | undefined): Promise<GatewayStatusRecordDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-statistic/gatewayStatusRecord?";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        if (recordType !== undefined)
            url_ += "recordType=" + encodeURIComponent("" + recordType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGatewayStatusRecord(_response);
        });
    }

    protected processGatewayStatusRecord(response: AxiosResponse): Promise<GatewayStatusRecordDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? GatewayStatusRecordDto.fromJS(resultData200) : new GatewayStatusRecordDto();
            return result200;
        }
        return Promise.resolve<GatewayStatusRecordDto>(<any>null);
    }

    /**
     * tenantGatewayCount
     * @return OK
     */
    tenantGatewayCount(): Promise<StatisticsGatewayVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iot-statistic/tenantGatewayCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTenantGatewayCount(_response);
        });
    }

    protected processTenantGatewayCount(response: AxiosResponse): Promise<StatisticsGatewayVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StatisticsGatewayVO.fromJS(resultData200) : new StatisticsGatewayVO();
            return result200;
        }
        return Promise.resolve<StatisticsGatewayVO>(<any>null);
    }
}

export class IotMetricsServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * activation
     * @param vo vo
     * @return OK
     */
    activation(vo: IotMetricsVo): Promise<IotMetricsDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iotMetrics/activation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vo);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processActivation(_response);
        });
    }

    protected processActivation(response: AxiosResponse): Promise<IotMetricsDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IotMetricsDto.fromJS(resultData200) : new IotMetricsDto();
            return result200;
        }
        return Promise.resolve<IotMetricsDto>(<any>null);
    }

    /**
     * dataAmount
     * @param vo vo
     * @return OK
     */
    dataAmount(vo: IotMetricsVo): Promise<IotMetricsDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iotMetrics/dataAmount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vo);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDataAmount(_response);
        });
    }

    protected processDataAmount(response: AxiosResponse): Promise<IotMetricsDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IotMetricsDto.fromJS(resultData200) : new IotMetricsDto();
            return result200;
        }
        return Promise.resolve<IotMetricsDto>(<any>null);
    }

    /**
     * dayActivity
     * @param vo vo
     * @return OK
     */
    dayActivity(vo: IotMetricsVo): Promise<IotMetricsDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iotMetrics/dayActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vo);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDayActivity(_response);
        });
    }

    protected processDayActivity(response: AxiosResponse): Promise<IotMetricsDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IotMetricsDto.fromJS(resultData200) : new IotMetricsDto();
            return result200;
        }
        return Promise.resolve<IotMetricsDto>(<any>null);
    }

    /**
     * findOverDateGatewayList
     * @param vo vo
     * @return OK
     */
    findOverDateGatewayList(vo: OverDateVo): Promise<GatewayBriefVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iotMetrics/findOverDateGatewayList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vo);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindOverDateGatewayList(_response);
        });
    }

    protected processFindOverDateGatewayList(response: AxiosResponse): Promise<GatewayBriefVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GatewayBriefVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<GatewayBriefVO[]>(<any>null);
    }

    /**
     * overDateCount
     * @param vo vo
     * @return OK
     */
    overDateCount(vo: OverDateVo): Promise<OverDateCountDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/iotMetrics/overDateCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vo);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOverDateCount(_response);
        });
    }

    protected processOverDateCount(response: AxiosResponse): Promise<OverDateCountDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OverDateCountDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<OverDateCountDto[]>(<any>null);
    }
}

export class NoticeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * longTimeNoConnection
     * @return OK
     */
    longTimeNoConnection(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/notice/longTimeNoConnection";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLongTimeNoConnection(_response);
        });
    }

    protected processLongTimeNoConnection(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProductBatchServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加批次
     * @param dto dto
     * @return OK
     */
    addProductBatch(dto: AddProductBatchDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/product-batch/add-product-batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddProductBatch(_response);
        });
    }

    protected processAddProductBatch(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 删除批次
     * @param batchNo batchNo
     * @return OK
     */
    deleteProductBatch(batchNo: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/product-batch/delete-product-batch?";
        if (batchNo === undefined || batchNo === null)
            throw new Error("The parameter 'batchNo' must be defined and cannot be null.");
        else
            url_ += "batchNo=" + encodeURIComponent("" + batchNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteProductBatch(_response);
        });
    }

    protected processDeleteProductBatch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询批次列表
     * @param filter (optional) filter
     * @return OK
     */
    getList(filter: string | null | undefined): Promise<ListResultVOOfProductBatchVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/product-batch/get-list?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ListResultVOOfProductBatchVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ListResultVOOfProductBatchVO.fromJS(resultData200) : new ListResultVOOfProductBatchVO();
            return result200;
        }
        return Promise.resolve<ListResultVOOfProductBatchVO>(<any>null);
    }

    /**
     * 分页查询批次信息
     * @param dto dto
     * @return OK
     */
    pageProductBatch(dto: PageProductBatchDTO): Promise<PagedResultVOOfProductBatchVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/product-batch/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageProductBatch(_response);
        });
    }

    protected processPageProductBatch(response: AxiosResponse): Promise<PagedResultVOOfProductBatchVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfProductBatchVO.fromJS(resultData200) : new PagedResultVOOfProductBatchVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfProductBatchVO>(<any>null);
    }

    /**
     * 修改批次信息
     * @param dto dto
     * @return OK
     */
    updateProductBatch(dto: UpdateProductBatchDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/product-batch/update-product-batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateProductBatch(_response);
        });
    }

    protected processUpdateProductBatch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ToolServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * initMakinoGatewayAppProperty
     * @param tenantId tenantId
     * @return OK
     */
    initMakinoGatewayAppProperty(tenantId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/tool/initMakinoGatewayAppProperty?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined and cannot be null.");
        else
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInitMakinoGatewayAppProperty(_response);
        });
    }

    protected processInitMakinoGatewayAppProperty(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class TransferRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getGatewayTransferRecord
     * @param transferRecordDTO transferRecordDTO
     * @return OK
     */
    getGatewayTransferRecord(transferRecordDTO: TransferRecordDTO): Promise<PagedResultVOOfTransferRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iot-console')+ "/transferRecord/get-gateway-transfer-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transferRecordDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGatewayTransferRecord(_response);
        });
    }

    protected processGetGatewayTransferRecord(response: AxiosResponse): Promise<PagedResultVOOfTransferRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfTransferRecordVO.fromJS(resultData200) : new PagedResultVOOfTransferRecordVO();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfTransferRecordVO>(<any>null);
    }
}

export class AddHubDTO implements IAddHubDTO {
    /** 域名 */
    host!: string | undefined;
    /** 端口 */
    port!: number | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IAddHubDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.host = data["host"];
            this.port = data["port"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): AddHubDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddHubDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["host"] = this.host;
        data["port"] = this.port;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IAddHubDTO {
    /** 域名 */
    host: string | undefined;
    /** 端口 */
    port: number | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class AddIotAppPropertyDTO implements IAddIotAppPropertyDTO {
    /** 地址参数 */
    addressParam!: string | undefined;
    /** 网关应用编号 */
    appCode!: number | undefined;
    /** 默认值 */
    defaultValue!: string | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 值倍率 */
    factor!: string | undefined;
    /** 网关SN */
    gatewayCode!: string | undefined;
    /** io地址 */
    ioAddressPrefix!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 数据类型 */
    type!: string | undefined;

    constructor(data?: IAddIotAppPropertyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.addressParam = data["addressParam"];
            this.appCode = data["appCode"];
            this.defaultValue = data["defaultValue"];
            this.description = data["description"];
            this.factor = data["factor"];
            this.gatewayCode = data["gatewayCode"];
            this.ioAddressPrefix = data["ioAddressPrefix"];
            this.name = data["name"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): AddIotAppPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddIotAppPropertyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressParam"] = this.addressParam;
        data["appCode"] = this.appCode;
        data["defaultValue"] = this.defaultValue;
        data["description"] = this.description;
        data["factor"] = this.factor;
        data["gatewayCode"] = this.gatewayCode;
        data["ioAddressPrefix"] = this.ioAddressPrefix;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }
}

export interface IAddIotAppPropertyDTO {
    /** 地址参数 */
    addressParam: string | undefined;
    /** 网关应用编号 */
    appCode: number | undefined;
    /** 默认值 */
    defaultValue: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 值倍率 */
    factor: string | undefined;
    /** 网关SN */
    gatewayCode: string | undefined;
    /** io地址 */
    ioAddressPrefix: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 数据类型 */
    type: string | undefined;
}

export class AddProductBatchDTO implements IAddProductBatchDTO {
    /** 网关最大授权数 */
    allowConnectionCount!: number;
    /** 硬件类型 */
    hardwareType!: string;
    /** IOT地址 */
    hubId!: string;
    /** 产品代码 */
    productCode!: string;
    /** 产品名称 */
    productName!: string;
    /** 产品类型 */
    productType!: number;
    /** 备注 */
    remark!: string | undefined;
    /** 目标租户 */
    tenantId!: string;
    /** 生产批次生产总量 */
    totalQuantity!: number;

    constructor(data?: IAddProductBatchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowConnectionCount = data["allowConnectionCount"];
            this.hardwareType = data["hardwareType"];
            this.hubId = data["hubId"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.productType = data["productType"];
            this.remark = data["remark"];
            this.tenantId = data["tenantId"];
            this.totalQuantity = data["totalQuantity"];
        }
    }

    static fromJS(data: any): AddProductBatchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductBatchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowConnectionCount"] = this.allowConnectionCount;
        data["hardwareType"] = this.hardwareType;
        data["hubId"] = this.hubId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        data["remark"] = this.remark;
        data["tenantId"] = this.tenantId;
        data["totalQuantity"] = this.totalQuantity;
        return data; 
    }
}

export interface IAddProductBatchDTO {
    /** 网关最大授权数 */
    allowConnectionCount: number;
    /** 硬件类型 */
    hardwareType: string;
    /** IOT地址 */
    hubId: string;
    /** 产品代码 */
    productCode: string;
    /** 产品名称 */
    productName: string;
    /** 产品类型 */
    productType: number;
    /** 备注 */
    remark: string | undefined;
    /** 目标租户 */
    tenantId: string;
    /** 生产批次生产总量 */
    totalQuantity: number;
}

export class AppMonitorLogDto implements IAppMonitorLogDto {
    appCode!: number | undefined;
    enabled!: boolean | undefined;
    gatewayCode!: string | undefined;

    constructor(data?: IAppMonitorLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.enabled = data["enabled"];
            this.gatewayCode = data["gatewayCode"];
        }
    }

    static fromJS(data: any): AppMonitorLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppMonitorLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["enabled"] = this.enabled;
        data["gatewayCode"] = this.gatewayCode;
        return data; 
    }
}

export interface IAppMonitorLogDto {
    appCode: number | undefined;
    enabled: boolean | undefined;
    gatewayCode: string | undefined;
}

export class AuthenticationVO implements IAuthenticationVO {
    /** AES密文字符串 */
    aesFile!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 首次上线时间 */
    firstOnlineTime!: Date | undefined;
    /** 边缘设备SN */
    gatewayCode!: string | undefined;
    /** 边缘设备主键 */
    gatewayId!: string | undefined;
    /** 网关名称 */
    gatewayName!: string | undefined;
    /** 状态[在线|离线] */
    isOnline!: string | undefined;
    /** 最后上线时间 */
    lastOnlineTime!: Date | undefined;
    /** SAAS平台解析密文接口地址 */
    parseAesAddress!: string | undefined;
    /** 产品代码 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型[3:软件边缘设备|1:硬件边缘设备] */
    productType!: string | undefined;

    constructor(data?: IAuthenticationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.aesFile = data["aesFile"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.firstOnlineTime = data["firstOnlineTime"] ? new Date(data["firstOnlineTime"].toString()) : <any>undefined;
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.gatewayName = data["gatewayName"];
            this.isOnline = data["isOnline"];
            this.lastOnlineTime = data["lastOnlineTime"] ? new Date(data["lastOnlineTime"].toString()) : <any>undefined;
            this.parseAesAddress = data["parseAesAddress"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.productType = data["productType"];
        }
    }

    static fromJS(data: any): AuthenticationVO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aesFile"] = this.aesFile;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["firstOnlineTime"] = this.firstOnlineTime ? this.firstOnlineTime.toISOString() : <any>undefined;
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["gatewayName"] = this.gatewayName;
        data["isOnline"] = this.isOnline;
        data["lastOnlineTime"] = this.lastOnlineTime ? this.lastOnlineTime.toISOString() : <any>undefined;
        data["parseAesAddress"] = this.parseAesAddress;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        return data; 
    }
}

export interface IAuthenticationVO {
    /** AES密文字符串 */
    aesFile: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 首次上线时间 */
    firstOnlineTime: Date | undefined;
    /** 边缘设备SN */
    gatewayCode: string | undefined;
    /** 边缘设备主键 */
    gatewayId: string | undefined;
    /** 网关名称 */
    gatewayName: string | undefined;
    /** 状态[在线|离线] */
    isOnline: string | undefined;
    /** 最后上线时间 */
    lastOnlineTime: Date | undefined;
    /** SAAS平台解析密文接口地址 */
    parseAesAddress: string | undefined;
    /** 产品代码 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型[3:软件边缘设备|1:硬件边缘设备] */
    productType: string | undefined;
}

export class CollectionItem implements ICollectionItem {
    /** 读写权限 */
    access!: number | undefined;
    /** 属性编号 */
    code!: number | undefined;
    /** 默认值 */
    defaultValue!: string | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 值倍率 */
    factor!: number | undefined;
    /** IO地址 */
    ioAddress!: string | undefined;
    /** 属性名称 */
    name!: string | undefined;
    /** 数据类型 */
    type!: number | undefined;

    constructor(data?: ICollectionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.access = data["access"];
            this.code = data["code"];
            this.defaultValue = data["defaultValue"];
            this.description = data["description"];
            this.factor = data["factor"];
            this.ioAddress = data["ioAddress"];
            this.name = data["name"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): CollectionItem {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access"] = this.access;
        data["code"] = this.code;
        data["defaultValue"] = this.defaultValue;
        data["description"] = this.description;
        data["factor"] = this.factor;
        data["ioAddress"] = this.ioAddress;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }
}

export interface ICollectionItem {
    /** 读写权限 */
    access: number | undefined;
    /** 属性编号 */
    code: number | undefined;
    /** 默认值 */
    defaultValue: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 值倍率 */
    factor: number | undefined;
    /** IO地址 */
    ioAddress: string | undefined;
    /** 属性名称 */
    name: string | undefined;
    /** 数据类型 */
    type: number | undefined;
}

export class CommunicationInfoVO implements ICommunicationInfoVO {
    /** 消息内容 */
    message!: string | undefined;
    /** 消息时间 */
    messageTime!: Date | undefined;
    /** 消息类型 */
    messageType!: string | undefined;

    constructor(data?: ICommunicationInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.messageTime = data["messageTime"] ? new Date(data["messageTime"].toString()) : <any>undefined;
            this.messageType = data["messageType"];
        }
    }

    static fromJS(data: any): CommunicationInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["messageTime"] = this.messageTime ? this.messageTime.toISOString() : <any>undefined;
        data["messageType"] = this.messageType;
        return data; 
    }
}

export interface ICommunicationInfoVO {
    /** 消息内容 */
    message: string | undefined;
    /** 消息时间 */
    messageTime: Date | undefined;
    /** 消息类型 */
    messageType: string | undefined;
}

export class ConfigureAppDto implements IConfigureAppDto {
    appCode!: number | undefined;
    deviceIp!: string | undefined;
    devicePort!: number | undefined;
    gatewayCode!: string | undefined;

    constructor(data?: IConfigureAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.deviceIp = data["deviceIp"];
            this.devicePort = data["devicePort"];
            this.gatewayCode = data["gatewayCode"];
        }
    }

    static fromJS(data: any): ConfigureAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigureAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["deviceIp"] = this.deviceIp;
        data["devicePort"] = this.devicePort;
        data["gatewayCode"] = this.gatewayCode;
        return data; 
    }
}

export interface IConfigureAppDto {
    appCode: number | undefined;
    deviceIp: string | undefined;
    devicePort: number | undefined;
    gatewayCode: string | undefined;
}

export class CustomerIotDto implements ICustomerIotDto {
    customer!: string | undefined;
    customerId!: string | undefined;
    gatewayCode!: string | undefined;
    isOnline!: boolean | undefined;
    lastOnlineTime!: Date | undefined;

    constructor(data?: ICustomerIotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customer = data["customer"];
            this.customerId = data["customerId"];
            this.gatewayCode = data["gatewayCode"];
            this.isOnline = data["isOnline"];
            this.lastOnlineTime = data["lastOnlineTime"] ? new Date(data["lastOnlineTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerIotDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerIotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer;
        data["customerId"] = this.customerId;
        data["gatewayCode"] = this.gatewayCode;
        data["isOnline"] = this.isOnline;
        data["lastOnlineTime"] = this.lastOnlineTime ? this.lastOnlineTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICustomerIotDto {
    customer: string | undefined;
    customerId: string | undefined;
    gatewayCode: string | undefined;
    isOnline: boolean | undefined;
    lastOnlineTime: Date | undefined;
}

export class DeleteFirmwareDTO implements IDeleteFirmwareDTO {
    firmwareIdList!: string[] | undefined;

    constructor(data?: IDeleteFirmwareDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["firmwareIdList"] && data["firmwareIdList"].constructor === Array) {
                this.firmwareIdList = [] as any;
                for (let item of data["firmwareIdList"])
                    this.firmwareIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteFirmwareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFirmwareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.firmwareIdList && this.firmwareIdList.constructor === Array) {
            data["firmwareIdList"] = [];
            for (let item of this.firmwareIdList)
                data["firmwareIdList"].push(item);
        }
        return data; 
    }
}

export interface IDeleteFirmwareDTO {
    firmwareIdList: string[] | undefined;
}

export class DeleteIotAppPropertyDTO implements IDeleteIotAppPropertyDTO {
    /** 删除的属性id集合 */
    propertyIdList!: string[] | undefined;

    constructor(data?: IDeleteIotAppPropertyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["propertyIdList"] && data["propertyIdList"].constructor === Array) {
                this.propertyIdList = [] as any;
                for (let item of data["propertyIdList"])
                    this.propertyIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteIotAppPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteIotAppPropertyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.propertyIdList && this.propertyIdList.constructor === Array) {
            data["propertyIdList"] = [];
            for (let item of this.propertyIdList)
                data["propertyIdList"].push(item);
        }
        return data; 
    }
}

export interface IDeleteIotAppPropertyDTO {
    /** 删除的属性id集合 */
    propertyIdList: string[] | undefined;
}

export class DeleteTemplateDTO implements IDeleteTemplateDTO {
    /** 要删除的模板主键 */
    templateIdList!: string[] | undefined;

    constructor(data?: IDeleteTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["templateIdList"] && data["templateIdList"].constructor === Array) {
                this.templateIdList = [] as any;
                for (let item of data["templateIdList"])
                    this.templateIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.templateIdList && this.templateIdList.constructor === Array) {
            data["templateIdList"] = [];
            for (let item of this.templateIdList)
                data["templateIdList"].push(item);
        }
        return data; 
    }
}

export interface IDeleteTemplateDTO {
    /** 要删除的模板主键 */
    templateIdList: string[] | undefined;
}

export class DeployModelTemplateDTO implements IDeployModelTemplateDTO {
    /** 配置目标网关应用编号 */
    appCode!: number | undefined;
    /** 配置目标网关SN */
    gatewayCode!: string | undefined;
    /** 使用的模板主键id */
    modelTemplateId!: string | undefined;

    constructor(data?: IDeployModelTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.gatewayCode = data["gatewayCode"];
            this.modelTemplateId = data["modelTemplateId"];
        }
    }

    static fromJS(data: any): DeployModelTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeployModelTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["gatewayCode"] = this.gatewayCode;
        data["modelTemplateId"] = this.modelTemplateId;
        return data; 
    }
}

export interface IDeployModelTemplateDTO {
    /** 配置目标网关应用编号 */
    appCode: number | undefined;
    /** 配置目标网关SN */
    gatewayCode: string | undefined;
    /** 使用的模板主键id */
    modelTemplateId: string | undefined;
}

export class EventVO implements IEventVO {
    /** 事件编号 */
    code!: number | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 所属网关编号 */
    gatewayCode!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 所属应用编号 */
    iotAppCode!: number | undefined;
    /** 最后一次上报内容 */
    lastReportContent!: string | undefined;
    /** 最后一次上报时间 */
    lastReportTime!: Date | undefined;
    /** 事件名称 */
    name!: string | undefined;

    constructor(data?: IEventVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.description = data["description"];
            this.gatewayCode = data["gatewayCode"];
            this.id = data["id"];
            this.iotAppCode = data["iotAppCode"];
            this.lastReportContent = data["lastReportContent"];
            this.lastReportTime = data["lastReportTime"] ? new Date(data["lastReportTime"].toString()) : <any>undefined;
            this.name = data["name"];
        }
    }

    static fromJS(data: any): EventVO {
        data = typeof data === 'object' ? data : {};
        let result = new EventVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["gatewayCode"] = this.gatewayCode;
        data["id"] = this.id;
        data["iotAppCode"] = this.iotAppCode;
        data["lastReportContent"] = this.lastReportContent;
        data["lastReportTime"] = this.lastReportTime ? this.lastReportTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data; 
    }
}

export interface IEventVO {
    /** 事件编号 */
    code: number | undefined;
    /** 描述 */
    description: string | undefined;
    /** 所属网关编号 */
    gatewayCode: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 所属应用编号 */
    iotAppCode: number | undefined;
    /** 最后一次上报内容 */
    lastReportContent: string | undefined;
    /** 最后一次上报时间 */
    lastReportTime: Date | undefined;
    /** 事件名称 */
    name: string | undefined;
}

export class ExecMethodDTO implements IExecMethodDTO {
    /** 网关应用编号 */
    appCode!: number | undefined;
    /** 执行参数 */
    execParamMap!: any;
    /** 网关SN */
    gatewayCode!: string | undefined;
    isAsync!: boolean | undefined;
    /** 应用方法编号 */
    methodId!: number;

    constructor(data?: IExecMethodDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.execParamMap = data["execParamMap"];
            this.gatewayCode = data["gatewayCode"];
            this.isAsync = data["isAsync"];
            this.methodId = data["methodId"];
        }
    }

    static fromJS(data: any): ExecMethodDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExecMethodDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["execParamMap"] = this.execParamMap;
        data["gatewayCode"] = this.gatewayCode;
        data["isAsync"] = this.isAsync;
        data["methodId"] = this.methodId;
        return data; 
    }
}

export interface IExecMethodDTO {
    /** 网关应用编号 */
    appCode: number | undefined;
    /** 执行参数 */
    execParamMap: any;
    /** 网关SN */
    gatewayCode: string | undefined;
    isAsync: boolean | undefined;
    /** 应用方法编号 */
    methodId: number;
}

export class ExecResultVO implements IExecResultVO {
    /** 响应消息 */
    message!: string | undefined;

    constructor(data?: IExecResultVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ExecResultVO {
        data = typeof data === 'object' ? data : {};
        let result = new ExecResultVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data; 
    }
}

export interface IExecResultVO {
    /** 响应消息 */
    message: string | undefined;
}

export class ExportAsTemplateDTO implements IExportAsTemplateDTO {
    /** 网关应用编号 */
    appCode!: number;
    /** 网关SN */
    gatewayCode!: string;
    /** 被替换的模板主键id 替换模板时传此参数 */
    oldTemplateId!: string | undefined;
    /** 模板名称 */
    templateName!: string;

    constructor(data?: IExportAsTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.gatewayCode = data["gatewayCode"];
            this.oldTemplateId = data["oldTemplateId"];
            this.templateName = data["templateName"];
        }
    }

    static fromJS(data: any): ExportAsTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportAsTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["gatewayCode"] = this.gatewayCode;
        data["oldTemplateId"] = this.oldTemplateId;
        data["templateName"] = this.templateName;
        return data; 
    }
}

export interface IExportAsTemplateDTO {
    /** 网关应用编号 */
    appCode: number;
    /** 网关SN */
    gatewayCode: string;
    /** 被替换的模板主键id 替换模板时传此参数 */
    oldTemplateId: string | undefined;
    /** 模板名称 */
    templateName: string;
}

export class ExtranetAppStatusBO implements IExtranetAppStatusBO {
    gatewayCode!: string | undefined;
    gatewayId!: string | undefined;
    status!: boolean | undefined;

    constructor(data?: IExtranetAppStatusBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): ExtranetAppStatusBO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtranetAppStatusBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IExtranetAppStatusBO {
    gatewayCode: string | undefined;
    gatewayId: string | undefined;
    status: boolean | undefined;
}

export class FirmwareIssueLogVO implements IFirmwareIssueLogVO {
    /** 动作 */
    action!: number | undefined;
    /** 动作执行结果 */
    actionEnd!: number | undefined;
    /** 发生时间 */
    createTime!: Date | undefined;
    /** 发行编号 */
    issueId!: string | undefined;

    constructor(data?: IFirmwareIssueLogVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.action = data["action"];
            this.actionEnd = data["actionEnd"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.issueId = data["issueId"];
        }
    }

    static fromJS(data: any): FirmwareIssueLogVO {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareIssueLogVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["actionEnd"] = this.actionEnd;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["issueId"] = this.issueId;
        return data; 
    }
}

export interface IFirmwareIssueLogVO {
    /** 动作 */
    action: number | undefined;
    /** 动作执行结果 */
    actionEnd: number | undefined;
    /** 发生时间 */
    createTime: Date | undefined;
    /** 发行编号 */
    issueId: string | undefined;
}

export class FirmwareIssueResultVO implements IFirmwareIssueResultVO {
    /** 固件下发时间 */
    createTime!: Date | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** 固件id */
    firmwareId!: string | undefined;
    /** 网关SN */
    gatewayCode!: string | undefined;
    /** 固件发行id */
    issueId!: string | undefined;
    /** 结果 */
    state!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: IFirmwareIssueResultVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.fileName = data["fileName"];
            this.firmwareId = data["firmwareId"];
            this.gatewayCode = data["gatewayCode"];
            this.issueId = data["issueId"];
            this.state = data["state"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): FirmwareIssueResultVO {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareIssueResultVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["firmwareId"] = this.firmwareId;
        data["gatewayCode"] = this.gatewayCode;
        data["issueId"] = this.issueId;
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IFirmwareIssueResultVO {
    /** 固件下发时间 */
    createTime: Date | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** 固件id */
    firmwareId: string | undefined;
    /** 网关SN */
    gatewayCode: string | undefined;
    /** 固件发行id */
    issueId: string | undefined;
    /** 结果 */
    state: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class FirmwareVO implements IFirmwareVO {
    /** 上传时间 */
    createTime!: Date | undefined;
    /** 文件ID */
    fileId!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** ID */
    id!: string | undefined;
    /** 大小[字节] */
    size!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 版本 */
    version!: string | undefined;

    constructor(data?: IFirmwareVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.id = data["id"];
            this.size = data["size"];
            this.tenantId = data["tenantId"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): FirmwareVO {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["id"] = this.id;
        data["size"] = this.size;
        data["tenantId"] = this.tenantId;
        data["version"] = this.version;
        return data; 
    }
}

export interface IFirmwareVO {
    /** 上传时间 */
    createTime: Date | undefined;
    /** 文件ID */
    fileId: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** ID */
    id: string | undefined;
    /** 大小[字节] */
    size: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 版本 */
    version: string | undefined;
}

export class FrequentOnlineGatewayVO implements IFrequentOnlineGatewayVO {
    count!: number | undefined;
    gatewayCode!: string | undefined;
    lastOfflineTime!: Date | undefined;
    lastOnlineTime!: Date | undefined;
    offlineTimeList!: Date[] | undefined;
    onlineTimeList!: Date[] | undefined;

    constructor(data?: IFrequentOnlineGatewayVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.count = data["count"];
            this.gatewayCode = data["gatewayCode"];
            this.lastOfflineTime = data["lastOfflineTime"] ? new Date(data["lastOfflineTime"].toString()) : <any>undefined;
            this.lastOnlineTime = data["lastOnlineTime"] ? new Date(data["lastOnlineTime"].toString()) : <any>undefined;
            if (data["offlineTimeList"] && data["offlineTimeList"].constructor === Array) {
                this.offlineTimeList = [] as any;
                for (let item of data["offlineTimeList"])
                    this.offlineTimeList!.push(new Date(item));
            }
            if (data["onlineTimeList"] && data["onlineTimeList"].constructor === Array) {
                this.onlineTimeList = [] as any;
                for (let item of data["onlineTimeList"])
                    this.onlineTimeList!.push(new Date(item));
            }
        }
    }

    static fromJS(data: any): FrequentOnlineGatewayVO {
        data = typeof data === 'object' ? data : {};
        let result = new FrequentOnlineGatewayVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["gatewayCode"] = this.gatewayCode;
        data["lastOfflineTime"] = this.lastOfflineTime ? this.lastOfflineTime.toISOString() : <any>undefined;
        data["lastOnlineTime"] = this.lastOnlineTime ? this.lastOnlineTime.toISOString() : <any>undefined;
        if (this.offlineTimeList && this.offlineTimeList.constructor === Array) {
            data["offlineTimeList"] = [];
            for (let item of this.offlineTimeList)
                data["offlineTimeList"].push(item.toISOString());
        }
        if (this.onlineTimeList && this.onlineTimeList.constructor === Array) {
            data["onlineTimeList"] = [];
            for (let item of this.onlineTimeList)
                data["onlineTimeList"].push(item.toISOString());
        }
        return data; 
    }
}

export interface IFrequentOnlineGatewayVO {
    count: number | undefined;
    gatewayCode: string | undefined;
    lastOfflineTime: Date | undefined;
    lastOnlineTime: Date | undefined;
    offlineTimeList: Date[] | undefined;
    onlineTimeList: Date[] | undefined;
}

export class GatewayBriefBO implements IGatewayBriefBO {
    gatewayCode!: string | undefined;
    gatewayId!: string | undefined;
    gatewayName!: string | undefined;
    gatewayType!: number | undefined;

    constructor(data?: IGatewayBriefBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.gatewayName = data["gatewayName"];
            this.gatewayType = data["gatewayType"];
        }
    }

    static fromJS(data: any): GatewayBriefBO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayBriefBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["gatewayName"] = this.gatewayName;
        data["gatewayType"] = this.gatewayType;
        return data; 
    }
}

export interface IGatewayBriefBO {
    gatewayCode: string | undefined;
    gatewayId: string | undefined;
    gatewayName: string | undefined;
    gatewayType: number | undefined;
}

export class GatewayBriefVO implements IGatewayBriefVO {
    gatewayCode!: string | undefined;
    lastOfflineTime!: Date | undefined;
    tenantId!: string | undefined;

    constructor(data?: IGatewayBriefVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.lastOfflineTime = data["lastOfflineTime"] ? new Date(data["lastOfflineTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): GatewayBriefVO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayBriefVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["lastOfflineTime"] = this.lastOfflineTime ? this.lastOfflineTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IGatewayBriefVO {
    gatewayCode: string | undefined;
    lastOfflineTime: Date | undefined;
    tenantId: string | undefined;
}

export class GatewayExportDTO implements IGatewayExportDTO {
    /** 批次号 */
    batchCode!: string | undefined;
    /** 关键词 */
    filter!: string | undefined;
    /** 是否已绑定工位 */
    hasWorkStation!: boolean | undefined;
    /** 选中数据集合 */
    idList!: string[] | undefined;
    /** 是否在线 */
    isOnline!: boolean | undefined;
    /** 租户code */
    tenantId!: string | undefined;
    /** 过滤条件:workStationId */
    workStationIdPattern!: string | undefined;

    constructor(data?: IGatewayExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchCode = data["batchCode"];
            this.filter = data["filter"];
            this.hasWorkStation = data["hasWorkStation"];
            if (data["idList"] && data["idList"].constructor === Array) {
                this.idList = [] as any;
                for (let item of data["idList"])
                    this.idList!.push(item);
            }
            this.isOnline = data["isOnline"];
            this.tenantId = data["tenantId"];
            this.workStationIdPattern = data["workStationIdPattern"];
        }
    }

    static fromJS(data: any): GatewayExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchCode"] = this.batchCode;
        data["filter"] = this.filter;
        data["hasWorkStation"] = this.hasWorkStation;
        if (this.idList && this.idList.constructor === Array) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        data["isOnline"] = this.isOnline;
        data["tenantId"] = this.tenantId;
        data["workStationIdPattern"] = this.workStationIdPattern;
        return data; 
    }
}

export interface IGatewayExportDTO {
    /** 批次号 */
    batchCode: string | undefined;
    /** 关键词 */
    filter: string | undefined;
    /** 是否已绑定工位 */
    hasWorkStation: boolean | undefined;
    /** 选中数据集合 */
    idList: string[] | undefined;
    /** 是否在线 */
    isOnline: boolean | undefined;
    /** 租户code */
    tenantId: string | undefined;
    /** 过滤条件:workStationId */
    workStationIdPattern: string | undefined;
}

export class GatewayExportVO implements IGatewayExportVO {
    /** 激活时间 */
    activatedTime!: Date | undefined;
    /** 应用数量 */
    allowConnectionCount!: number | undefined;
    /** 批量编号 */
    batchNo!: string | undefined;
    /** 城市编码 */
    cityCode!: string | undefined;
    /** 网关code */
    code!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    createUser!: string | undefined;
    /** 创建人 */
    createUserName!: string | undefined;
    /** 第一次上线事件 */
    firstOnlineTime!: Date | undefined;
    /** ICCID */
    iccid!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否重复 */
    isMaybeSomeCode!: boolean | undefined;
    /** 是否在线 */
    isOnline!: boolean | undefined;
    /** 是否分享 */
    isShared!: boolean | undefined;
    /** 最后一次离线时间 */
    lastOfflineTime!: Date | undefined;
    /** 最后一次在线时间 */
    lastOnlineTime!: Date | undefined;
    /** 备注 */
    name!: string | undefined;
    /** 运营商 */
    operatorCode!: string | undefined;
    /** 网关类型,1:硬件,3:软件 */
    type!: number | undefined;
    /** 关联的工位编码 */
    workStationCode!: string | undefined;
    /** 关联的工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IGatewayExportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activatedTime = data["activatedTime"] ? new Date(data["activatedTime"].toString()) : <any>undefined;
            this.allowConnectionCount = data["allowConnectionCount"];
            this.batchNo = data["batchNo"];
            this.cityCode = data["cityCode"];
            this.code = data["code"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.createUserName = data["createUserName"];
            this.firstOnlineTime = data["firstOnlineTime"] ? new Date(data["firstOnlineTime"].toString()) : <any>undefined;
            this.iccid = data["iccid"];
            this.id = data["id"];
            this.isMaybeSomeCode = data["isMaybeSomeCode"];
            this.isOnline = data["isOnline"];
            this.isShared = data["isShared"];
            this.lastOfflineTime = data["lastOfflineTime"] ? new Date(data["lastOfflineTime"].toString()) : <any>undefined;
            this.lastOnlineTime = data["lastOnlineTime"] ? new Date(data["lastOnlineTime"].toString()) : <any>undefined;
            this.name = data["name"];
            this.operatorCode = data["operatorCode"];
            this.type = data["type"];
            this.workStationCode = data["workStationCode"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): GatewayExportVO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayExportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activatedTime"] = this.activatedTime ? this.activatedTime.toISOString() : <any>undefined;
        data["allowConnectionCount"] = this.allowConnectionCount;
        data["batchNo"] = this.batchNo;
        data["cityCode"] = this.cityCode;
        data["code"] = this.code;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["createUserName"] = this.createUserName;
        data["firstOnlineTime"] = this.firstOnlineTime ? this.firstOnlineTime.toISOString() : <any>undefined;
        data["iccid"] = this.iccid;
        data["id"] = this.id;
        data["isMaybeSomeCode"] = this.isMaybeSomeCode;
        data["isOnline"] = this.isOnline;
        data["isShared"] = this.isShared;
        data["lastOfflineTime"] = this.lastOfflineTime ? this.lastOfflineTime.toISOString() : <any>undefined;
        data["lastOnlineTime"] = this.lastOnlineTime ? this.lastOnlineTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["operatorCode"] = this.operatorCode;
        data["type"] = this.type;
        data["workStationCode"] = this.workStationCode;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IGatewayExportVO {
    /** 激活时间 */
    activatedTime: Date | undefined;
    /** 应用数量 */
    allowConnectionCount: number | undefined;
    /** 批量编号 */
    batchNo: string | undefined;
    /** 城市编码 */
    cityCode: string | undefined;
    /** 网关code */
    code: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    createUser: string | undefined;
    /** 创建人 */
    createUserName: string | undefined;
    /** 第一次上线事件 */
    firstOnlineTime: Date | undefined;
    /** ICCID */
    iccid: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否重复 */
    isMaybeSomeCode: boolean | undefined;
    /** 是否在线 */
    isOnline: boolean | undefined;
    /** 是否分享 */
    isShared: boolean | undefined;
    /** 最后一次离线时间 */
    lastOfflineTime: Date | undefined;
    /** 最后一次在线时间 */
    lastOnlineTime: Date | undefined;
    /** 备注 */
    name: string | undefined;
    /** 运营商 */
    operatorCode: string | undefined;
    /** 网关类型,1:硬件,3:软件 */
    type: number | undefined;
    /** 关联的工位编码 */
    workStationCode: string | undefined;
    /** 关联的工位名称 */
    workStationName: string | undefined;
}

export class GatewayStatusRecordDto implements IGatewayStatusRecordDto {
    list!: CustomerIotDto[] | undefined;
    num!: number | undefined;
    onlineNumber!: number | undefined;
    total!: number | undefined;

    constructor(data?: IGatewayStatusRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(CustomerIotDto.fromJS(item));
            }
            this.num = data["num"];
            this.onlineNumber = data["onlineNumber"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): GatewayStatusRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayStatusRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["num"] = this.num;
        data["onlineNumber"] = this.onlineNumber;
        data["total"] = this.total;
        return data; 
    }
}

export interface IGatewayStatusRecordDto {
    list: CustomerIotDto[] | undefined;
    num: number | undefined;
    onlineNumber: number | undefined;
    total: number | undefined;
}

export class GatewayTransferDTO implements IGatewayTransferDTO {
    gatewayIds!: string[] | undefined;
    newTenantId!: string | undefined;
    newTenantName!: string | undefined;

    constructor(data?: IGatewayTransferDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["gatewayIds"] && data["gatewayIds"].constructor === Array) {
                this.gatewayIds = [] as any;
                for (let item of data["gatewayIds"])
                    this.gatewayIds!.push(item);
            }
            this.newTenantId = data["newTenantId"];
            this.newTenantName = data["newTenantName"];
        }
    }

    static fromJS(data: any): GatewayTransferDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayTransferDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.gatewayIds && this.gatewayIds.constructor === Array) {
            data["gatewayIds"] = [];
            for (let item of this.gatewayIds)
                data["gatewayIds"].push(item);
        }
        data["newTenantId"] = this.newTenantId;
        data["newTenantName"] = this.newTenantName;
        return data; 
    }
}

export interface IGatewayTransferDTO {
    gatewayIds: string[] | undefined;
    newTenantId: string | undefined;
    newTenantName: string | undefined;
}

export class GatewayVO implements IGatewayVO {
    /** 激活时间 */
    activatedTime!: Date | undefined;
    /** 应用数量 */
    allowConnectionCount!: number | undefined;
    /** 关联的工位id */
    associateWorkStations!: string[] | undefined;
    /** 批量编号 */
    batchNo!: string | undefined;
    /** 城市编码 */
    cityCode!: string | undefined;
    /** 网关code */
    code!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    createUser!: string | undefined;
    /** 创建人 */
    createUserName!: string | undefined;
    /** 硬件类型 */
    hardwareType!: string | undefined;
    /** ICCID */
    iccid!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    imei!: string | undefined;
    imsi!: string | undefined;
    /** 是否重复 */
    isMaybeSomeCode!: boolean | undefined;
    /** 是否在线 */
    isOnline!: boolean | undefined;
    /** 是否分享 */
    isShared!: boolean | undefined;
    /** 最后一次离线时间 */
    lastOfflineTime!: Date | undefined;
    /** 最后一次在线时间 */
    lastOnlineTime!: Date | undefined;
    /** 备注 */
    name!: string | undefined;
    /** 运营商 */
    operatorCode!: string | undefined;
    rssi!: string | undefined;
    /** 租户ID */
    tenantIds!: string | undefined;
    /** 网关类型,1:硬件,3:软件 */
    type!: number | undefined;

    constructor(data?: IGatewayVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activatedTime = data["activatedTime"] ? new Date(data["activatedTime"].toString()) : <any>undefined;
            this.allowConnectionCount = data["allowConnectionCount"];
            if (data["associateWorkStations"] && data["associateWorkStations"].constructor === Array) {
                this.associateWorkStations = [] as any;
                for (let item of data["associateWorkStations"])
                    this.associateWorkStations!.push(item);
            }
            this.batchNo = data["batchNo"];
            this.cityCode = data["cityCode"];
            this.code = data["code"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.createUserName = data["createUserName"];
            this.hardwareType = data["hardwareType"];
            this.iccid = data["iccid"];
            this.id = data["id"];
            this.imei = data["imei"];
            this.imsi = data["imsi"];
            this.isMaybeSomeCode = data["isMaybeSomeCode"];
            this.isOnline = data["isOnline"];
            this.isShared = data["isShared"];
            this.lastOfflineTime = data["lastOfflineTime"] ? new Date(data["lastOfflineTime"].toString()) : <any>undefined;
            this.lastOnlineTime = data["lastOnlineTime"] ? new Date(data["lastOnlineTime"].toString()) : <any>undefined;
            this.name = data["name"];
            this.operatorCode = data["operatorCode"];
            this.rssi = data["rssi"];
            this.tenantIds = data["tenantIds"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): GatewayVO {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activatedTime"] = this.activatedTime ? this.activatedTime.toISOString() : <any>undefined;
        data["allowConnectionCount"] = this.allowConnectionCount;
        if (this.associateWorkStations && this.associateWorkStations.constructor === Array) {
            data["associateWorkStations"] = [];
            for (let item of this.associateWorkStations)
                data["associateWorkStations"].push(item);
        }
        data["batchNo"] = this.batchNo;
        data["cityCode"] = this.cityCode;
        data["code"] = this.code;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["createUserName"] = this.createUserName;
        data["hardwareType"] = this.hardwareType;
        data["iccid"] = this.iccid;
        data["id"] = this.id;
        data["imei"] = this.imei;
        data["imsi"] = this.imsi;
        data["isMaybeSomeCode"] = this.isMaybeSomeCode;
        data["isOnline"] = this.isOnline;
        data["isShared"] = this.isShared;
        data["lastOfflineTime"] = this.lastOfflineTime ? this.lastOfflineTime.toISOString() : <any>undefined;
        data["lastOnlineTime"] = this.lastOnlineTime ? this.lastOnlineTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["operatorCode"] = this.operatorCode;
        data["rssi"] = this.rssi;
        data["tenantIds"] = this.tenantIds;
        data["type"] = this.type;
        return data; 
    }
}

export interface IGatewayVO {
    /** 激活时间 */
    activatedTime: Date | undefined;
    /** 应用数量 */
    allowConnectionCount: number | undefined;
    /** 关联的工位id */
    associateWorkStations: string[] | undefined;
    /** 批量编号 */
    batchNo: string | undefined;
    /** 城市编码 */
    cityCode: string | undefined;
    /** 网关code */
    code: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    createUser: string | undefined;
    /** 创建人 */
    createUserName: string | undefined;
    /** 硬件类型 */
    hardwareType: string | undefined;
    /** ICCID */
    iccid: string | undefined;
    /** 主键id */
    id: string | undefined;
    imei: string | undefined;
    imsi: string | undefined;
    /** 是否重复 */
    isMaybeSomeCode: boolean | undefined;
    /** 是否在线 */
    isOnline: boolean | undefined;
    /** 是否分享 */
    isShared: boolean | undefined;
    /** 最后一次离线时间 */
    lastOfflineTime: Date | undefined;
    /** 最后一次在线时间 */
    lastOnlineTime: Date | undefined;
    /** 备注 */
    name: string | undefined;
    /** 运营商 */
    operatorCode: string | undefined;
    rssi: string | undefined;
    /** 租户ID */
    tenantIds: string | undefined;
    /** 网关类型,1:硬件,3:软件 */
    type: number | undefined;
}

export class GetIotAppPropertyPageListDTO implements IGetIotAppPropertyPageListDTO {
    appCode!: string | undefined;
    ascs!: string | undefined;
    current!: number | undefined;
    descs!: string | undefined;
    filter!: string | undefined;
    gatewayCode!: string | undefined;
    size!: number | undefined;

    constructor(data?: IGetIotAppPropertyPageListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.ascs = data["ascs"];
            this.current = data["current"];
            this.descs = data["descs"];
            this.filter = data["filter"];
            this.gatewayCode = data["gatewayCode"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): GetIotAppPropertyPageListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetIotAppPropertyPageListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["ascs"] = this.ascs;
        data["current"] = this.current;
        data["descs"] = this.descs;
        data["filter"] = this.filter;
        data["gatewayCode"] = this.gatewayCode;
        data["size"] = this.size;
        return data; 
    }
}

export interface IGetIotAppPropertyPageListDTO {
    appCode: string | undefined;
    ascs: string | undefined;
    current: number | undefined;
    descs: string | undefined;
    filter: string | undefined;
    gatewayCode: string | undefined;
    size: number | undefined;
}

export class HubVO implements IHubVO {
    /** 网关端口 */
    gatewayPort!: string | undefined;
    /** 域名 */
    host!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 端口 */
    port!: number | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IHubVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayPort = data["gatewayPort"];
            this.host = data["host"];
            this.id = data["id"];
            this.port = data["port"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): HubVO {
        data = typeof data === 'object' ? data : {};
        let result = new HubVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayPort"] = this.gatewayPort;
        data["host"] = this.host;
        data["id"] = this.id;
        data["port"] = this.port;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IHubVO {
    /** 网关端口 */
    gatewayPort: string | undefined;
    /** 域名 */
    host: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 端口 */
    port: number | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class IoAddressVO implements IIoAddressVO {
    /** 描述 */
    description!: string | undefined;
    /** 所属网关SN */
    gatewayCode!: string | undefined;
    /** 所属应用编号 */
    iotAppCode!: number | undefined;
    /** 地址名称 */
    name!: string | undefined;
    /** 参数 */
    parameters!: string | undefined;
    /** 返回类型 */
    returnType!: string | undefined;

    constructor(data?: IIoAddressVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.gatewayCode = data["gatewayCode"];
            this.iotAppCode = data["iotAppCode"];
            this.name = data["name"];
            this.parameters = data["parameters"];
            this.returnType = data["returnType"];
        }
    }

    static fromJS(data: any): IoAddressVO {
        data = typeof data === 'object' ? data : {};
        let result = new IoAddressVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["gatewayCode"] = this.gatewayCode;
        data["iotAppCode"] = this.iotAppCode;
        data["name"] = this.name;
        data["parameters"] = this.parameters;
        data["returnType"] = this.returnType;
        return data; 
    }
}

export interface IIoAddressVO {
    /** 描述 */
    description: string | undefined;
    /** 所属网关SN */
    gatewayCode: string | undefined;
    /** 所属应用编号 */
    iotAppCode: number | undefined;
    /** 地址名称 */
    name: string | undefined;
    /** 参数 */
    parameters: string | undefined;
    /** 返回类型 */
    returnType: string | undefined;
}

export class IotAbnormalConnectionVO implements IIotAbnormalConnectionVO {
    /** 设备应用id */
    appId!: string | undefined;
    /** 客户端IP */
    clientIp!: string | undefined;
    /** 客户端端口 */
    clientPort!: number | undefined;
    /** 设备code */
    deviceCode!: string | undefined;
    /** 异常类型 */
    exception!: string | undefined;
    /** 异常信息 */
    exceptionMessage!: string | undefined;
    /** 堆栈信息 */
    exceptionStackMsg!: string | undefined;
    /** 友好提示 */
    friendlyMessage!: string | undefined;
    /** 服务器IP */
    serveIp!: string | undefined;
    /** 服务器端口 */
    servePort!: number | undefined;
    /** 触发时间 */
    time!: Date | undefined;

    constructor(data?: IIotAbnormalConnectionVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appId = data["appId"];
            this.clientIp = data["clientIp"];
            this.clientPort = data["clientPort"];
            this.deviceCode = data["deviceCode"];
            this.exception = data["exception"];
            this.exceptionMessage = data["exceptionMessage"];
            this.exceptionStackMsg = data["exceptionStackMsg"];
            this.friendlyMessage = data["friendlyMessage"];
            this.serveIp = data["serveIp"];
            this.servePort = data["servePort"];
            this.time = data["time"] ? new Date(data["time"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IotAbnormalConnectionVO {
        data = typeof data === 'object' ? data : {};
        let result = new IotAbnormalConnectionVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["clientIp"] = this.clientIp;
        data["clientPort"] = this.clientPort;
        data["deviceCode"] = this.deviceCode;
        data["exception"] = this.exception;
        data["exceptionMessage"] = this.exceptionMessage;
        data["exceptionStackMsg"] = this.exceptionStackMsg;
        data["friendlyMessage"] = this.friendlyMessage;
        data["serveIp"] = this.serveIp;
        data["servePort"] = this.servePort;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IIotAbnormalConnectionVO {
    /** 设备应用id */
    appId: string | undefined;
    /** 客户端IP */
    clientIp: string | undefined;
    /** 客户端端口 */
    clientPort: number | undefined;
    /** 设备code */
    deviceCode: string | undefined;
    /** 异常类型 */
    exception: string | undefined;
    /** 异常信息 */
    exceptionMessage: string | undefined;
    /** 堆栈信息 */
    exceptionStackMsg: string | undefined;
    /** 友好提示 */
    friendlyMessage: string | undefined;
    /** 服务器IP */
    serveIp: string | undefined;
    /** 服务器端口 */
    servePort: number | undefined;
    /** 触发时间 */
    time: Date | undefined;
}

export class IotAppBriefBO implements IIotAppBriefBO {
    gatewayCode!: string | undefined;
    iotAppCode!: number | undefined;
    iotAppId!: string | undefined;
    iotAppName!: string | undefined;
    iotAppState!: number | undefined;
    iotAppTypeName!: string | undefined;
    iotAppVersion!: string | undefined;

    constructor(data?: IIotAppBriefBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.iotAppCode = data["iotAppCode"];
            this.iotAppId = data["iotAppId"];
            this.iotAppName = data["iotAppName"];
            this.iotAppState = data["iotAppState"];
            this.iotAppTypeName = data["iotAppTypeName"];
            this.iotAppVersion = data["iotAppVersion"];
        }
    }

    static fromJS(data: any): IotAppBriefBO {
        data = typeof data === 'object' ? data : {};
        let result = new IotAppBriefBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["iotAppCode"] = this.iotAppCode;
        data["iotAppId"] = this.iotAppId;
        data["iotAppName"] = this.iotAppName;
        data["iotAppState"] = this.iotAppState;
        data["iotAppTypeName"] = this.iotAppTypeName;
        data["iotAppVersion"] = this.iotAppVersion;
        return data; 
    }
}

export interface IIotAppBriefBO {
    gatewayCode: string | undefined;
    iotAppCode: number | undefined;
    iotAppId: string | undefined;
    iotAppName: string | undefined;
    iotAppState: number | undefined;
    iotAppTypeName: string | undefined;
    iotAppVersion: string | undefined;
}

export class IotAppVO implements IIotAppVO {
    /** 应用编号 */
    code!: number | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 驱动名称 */
    driverName!: string | undefined;
    /** 所属网关编号 */
    gatewayCode!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否在线 */
    isOnline!: boolean | undefined;
    /** 描述 */
    logMonitoring!: boolean | undefined;
    /** 应用名称 */
    name!: string | undefined;

    constructor(data?: IIotAppVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.description = data["description"];
            this.driverName = data["driverName"];
            this.gatewayCode = data["gatewayCode"];
            this.id = data["id"];
            this.isOnline = data["isOnline"];
            this.logMonitoring = data["logMonitoring"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): IotAppVO {
        data = typeof data === 'object' ? data : {};
        let result = new IotAppVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["driverName"] = this.driverName;
        data["gatewayCode"] = this.gatewayCode;
        data["id"] = this.id;
        data["isOnline"] = this.isOnline;
        data["logMonitoring"] = this.logMonitoring;
        data["name"] = this.name;
        return data; 
    }
}

export interface IIotAppVO {
    /** 应用编号 */
    code: number | undefined;
    /** 描述 */
    description: string | undefined;
    /** 驱动名称 */
    driverName: string | undefined;
    /** 所属网关编号 */
    gatewayCode: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否在线 */
    isOnline: boolean | undefined;
    /** 描述 */
    logMonitoring: boolean | undefined;
    /** 应用名称 */
    name: string | undefined;
}

export class IotMessageStatisticsVO implements IIotMessageStatisticsVO {
    appCode!: number | undefined;
    gatewayCode!: string | undefined;
    messageSize!: string | undefined;
    messageTotal!: number | undefined;
    statisticsTime!: string | undefined;

    constructor(data?: IIotMessageStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.gatewayCode = data["gatewayCode"];
            this.messageSize = data["messageSize"];
            this.messageTotal = data["messageTotal"];
            this.statisticsTime = data["statisticsTime"];
        }
    }

    static fromJS(data: any): IotMessageStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new IotMessageStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["gatewayCode"] = this.gatewayCode;
        data["messageSize"] = this.messageSize;
        data["messageTotal"] = this.messageTotal;
        data["statisticsTime"] = this.statisticsTime;
        return data; 
    }
}

export interface IIotMessageStatisticsVO {
    appCode: number | undefined;
    gatewayCode: string | undefined;
    messageSize: string | undefined;
    messageTotal: number | undefined;
    statisticsTime: string | undefined;
}

export class IotMetricsDto implements IIotMetricsDto {
    itemList!: IotMetricsItemDto[] | undefined;

    constructor(data?: IIotMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["itemList"] && data["itemList"].constructor === Array) {
                this.itemList = [] as any;
                for (let item of data["itemList"])
                    this.itemList!.push(IotMetricsItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IotMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IotMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.itemList && this.itemList.constructor === Array) {
            data["itemList"] = [];
            for (let item of this.itemList)
                data["itemList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIotMetricsDto {
    itemList: IotMetricsItemDto[] | undefined;
}

export class IotMetricsItemDto implements IIotMetricsItemDto {
    key!: string | undefined;
    value!: string | undefined;

    constructor(data?: IIotMetricsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): IotMetricsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IotMetricsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }
}

export interface IIotMetricsItemDto {
    key: string | undefined;
    value: string | undefined;
}

export class IotMetricsVo implements IIotMetricsVo {
    dateType!: number | undefined;
    end!: Date | undefined;
    start!: Date | undefined;

    constructor(data?: IIotMetricsVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateType = data["dateType"];
            this.end = data["end"] ? new Date(data["end"].toString()) : <any>undefined;
            this.start = data["start"] ? new Date(data["start"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IotMetricsVo {
        data = typeof data === 'object' ? data : {};
        let result = new IotMetricsVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateType"] = this.dateType;
        data["end"] = this.end ? formatDate(this.end) : <any>undefined;
        data["start"] = this.start ? formatDate(this.start) : <any>undefined;
        return data; 
    }
}

export interface IIotMetricsVo {
    dateType: number | undefined;
    end: Date | undefined;
    start: Date | undefined;
}

export class IotModelNode implements IIotModelNode {
    /** 节点ip */
    ip!: string | undefined;
    /** 节点连接数 */
    load!: string | undefined;
    /** 节点名称 */
    name!: string | undefined;
    /** 节点断开 */
    port!: number | undefined;

    constructor(data?: IIotModelNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ip = data["ip"];
            this.load = data["load"];
            this.name = data["name"];
            this.port = data["port"];
        }
    }

    static fromJS(data: any): IotModelNode {
        data = typeof data === 'object' ? data : {};
        let result = new IotModelNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ip"] = this.ip;
        data["load"] = this.load;
        data["name"] = this.name;
        data["port"] = this.port;
        return data; 
    }
}

export interface IIotModelNode {
    /** 节点ip */
    ip: string | undefined;
    /** 节点连接数 */
    load: string | undefined;
    /** 节点名称 */
    name: string | undefined;
    /** 节点断开 */
    port: number | undefined;
}

export class IotPropertyValue implements IIotPropertyValue {
    dataValue!: string | undefined;
    datatype!: number | undefined;
    propertyCode!: number | undefined;

    constructor(data?: IIotPropertyValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataValue = data["dataValue"];
            this.datatype = data["datatype"];
            this.propertyCode = data["propertyCode"];
        }
    }

    static fromJS(data: any): IotPropertyValue {
        data = typeof data === 'object' ? data : {};
        let result = new IotPropertyValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataValue"] = this.dataValue;
        data["datatype"] = this.datatype;
        data["propertyCode"] = this.propertyCode;
        return data; 
    }
}

export interface IIotPropertyValue {
    dataValue: string | undefined;
    datatype: number | undefined;
    propertyCode: number | undefined;
}

export class IssueFirmwareDTO implements IIssueFirmwareDTO {
    /** 固件ID */
    firmwareId!: string | undefined;
    /** 网关Code集合 */
    gatewayCodeList!: string[] | undefined;

    constructor(data?: IIssueFirmwareDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firmwareId = data["firmwareId"];
            if (data["gatewayCodeList"] && data["gatewayCodeList"].constructor === Array) {
                this.gatewayCodeList = [] as any;
                for (let item of data["gatewayCodeList"])
                    this.gatewayCodeList!.push(item);
            }
        }
    }

    static fromJS(data: any): IssueFirmwareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IssueFirmwareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firmwareId"] = this.firmwareId;
        if (this.gatewayCodeList && this.gatewayCodeList.constructor === Array) {
            data["gatewayCodeList"] = [];
            for (let item of this.gatewayCodeList)
                data["gatewayCodeList"].push(item);
        }
        return data; 
    }
}

export interface IIssueFirmwareDTO {
    /** 固件ID */
    firmwareId: string | undefined;
    /** 网关Code集合 */
    gatewayCodeList: string[] | undefined;
}

export class LatestPropertyDataDTO implements ILatestPropertyDataDTO {
    appCode!: number | undefined;
    gatewayCode!: string | undefined;
    propertyName!: string | undefined;

    constructor(data?: ILatestPropertyDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.gatewayCode = data["gatewayCode"];
            this.propertyName = data["propertyName"];
        }
    }

    static fromJS(data: any): LatestPropertyDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LatestPropertyDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["gatewayCode"] = this.gatewayCode;
        data["propertyName"] = this.propertyName;
        return data; 
    }
}

export interface ILatestPropertyDataDTO {
    appCode: number | undefined;
    gatewayCode: string | undefined;
    propertyName: string | undefined;
}

export class LinkGatewayTenantDTO implements ILinkGatewayTenantDTO {
    gatewayIdList!: string[] | undefined;
    sourceTenantId!: string | undefined;
    targetTenantId!: string | undefined;

    constructor(data?: ILinkGatewayTenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["gatewayIdList"] && data["gatewayIdList"].constructor === Array) {
                this.gatewayIdList = [] as any;
                for (let item of data["gatewayIdList"])
                    this.gatewayIdList!.push(item);
            }
            this.sourceTenantId = data["sourceTenantId"];
            this.targetTenantId = data["targetTenantId"];
        }
    }

    static fromJS(data: any): LinkGatewayTenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LinkGatewayTenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.gatewayIdList && this.gatewayIdList.constructor === Array) {
            data["gatewayIdList"] = [];
            for (let item of this.gatewayIdList)
                data["gatewayIdList"].push(item);
        }
        data["sourceTenantId"] = this.sourceTenantId;
        data["targetTenantId"] = this.targetTenantId;
        return data; 
    }
}

export interface ILinkGatewayTenantDTO {
    gatewayIdList: string[] | undefined;
    sourceTenantId: string | undefined;
    targetTenantId: string | undefined;
}

export class ListResultVOOfEventVO implements IListResultVOOfEventVO {
    items!: EventVO[] | undefined;

    constructor(data?: IListResultVOOfEventVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EventVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfEventVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfEventVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfEventVO {
    items: EventVO[] | undefined;
}

export class ListResultVOOfFrequentOnlineGatewayVO implements IListResultVOOfFrequentOnlineGatewayVO {
    items!: FrequentOnlineGatewayVO[] | undefined;

    constructor(data?: IListResultVOOfFrequentOnlineGatewayVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FrequentOnlineGatewayVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfFrequentOnlineGatewayVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfFrequentOnlineGatewayVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfFrequentOnlineGatewayVO {
    items: FrequentOnlineGatewayVO[] | undefined;
}

export class ListResultVOOfGatewayVO implements IListResultVOOfGatewayVO {
    items!: GatewayVO[] | undefined;

    constructor(data?: IListResultVOOfGatewayVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GatewayVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfGatewayVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfGatewayVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfGatewayVO {
    items: GatewayVO[] | undefined;
}

export class ListResultVOOfHubVO implements IListResultVOOfHubVO {
    items!: HubVO[] | undefined;

    constructor(data?: IListResultVOOfHubVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(HubVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfHubVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfHubVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfHubVO {
    items: HubVO[] | undefined;
}

export class ListResultVOOfIoAddressVO implements IListResultVOOfIoAddressVO {
    items!: IoAddressVO[] | undefined;

    constructor(data?: IListResultVOOfIoAddressVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(IoAddressVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfIoAddressVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfIoAddressVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfIoAddressVO {
    items: IoAddressVO[] | undefined;
}

export class ListResultVOOfIotAppVO implements IListResultVOOfIotAppVO {
    items!: IotAppVO[] | undefined;

    constructor(data?: IListResultVOOfIotAppVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(IotAppVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfIotAppVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfIotAppVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfIotAppVO {
    items: IotAppVO[] | undefined;
}

export class ListResultVOOfIotMessageStatisticsVO implements IListResultVOOfIotMessageStatisticsVO {
    items!: IotMessageStatisticsVO[] | undefined;

    constructor(data?: IListResultVOOfIotMessageStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(IotMessageStatisticsVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfIotMessageStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfIotMessageStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfIotMessageStatisticsVO {
    items: IotMessageStatisticsVO[] | undefined;
}

export class ListResultVOOfIotModelNode implements IListResultVOOfIotModelNode {
    items!: IotModelNode[] | undefined;

    constructor(data?: IListResultVOOfIotModelNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(IotModelNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfIotModelNode {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfIotModelNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfIotModelNode {
    items: IotModelNode[] | undefined;
}

export class ListResultVOOfMethodParamVO implements IListResultVOOfMethodParamVO {
    items!: MethodParamVO[] | undefined;

    constructor(data?: IListResultVOOfMethodParamVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(MethodParamVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfMethodParamVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfMethodParamVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfMethodParamVO {
    items: MethodParamVO[] | undefined;
}

export class ListResultVOOfMethodVO implements IListResultVOOfMethodVO {
    items!: MethodVO[] | undefined;

    constructor(data?: IListResultVOOfMethodVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(MethodVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfMethodVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfMethodVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfMethodVO {
    items: MethodVO[] | undefined;
}

export class ListResultVOOfModelTemplateBriefVO implements IListResultVOOfModelTemplateBriefVO {
    items!: ModelTemplateBriefVO[] | undefined;

    constructor(data?: IListResultVOOfModelTemplateBriefVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ModelTemplateBriefVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfModelTemplateBriefVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfModelTemplateBriefVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfModelTemplateBriefVO {
    items: ModelTemplateBriefVO[] | undefined;
}

export class ListResultVOOfProductBatchVO implements IListResultVOOfProductBatchVO {
    items!: ProductBatchVO[] | undefined;

    constructor(data?: IListResultVOOfProductBatchVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ProductBatchVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfProductBatchVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfProductBatchVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfProductBatchVO {
    items: ProductBatchVO[] | undefined;
}

export class ListResultVOOfPropertyListVO implements IListResultVOOfPropertyListVO {
    items!: PropertyListVO[] | undefined;

    constructor(data?: IListResultVOOfPropertyListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PropertyListVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfPropertyListVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfPropertyListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfPropertyListVO {
    items: PropertyListVO[] | undefined;
}

export class ListResultVOOfPropertyVO implements IListResultVOOfPropertyVO {
    items!: PropertyVO[] | undefined;

    constructor(data?: IListResultVOOfPropertyVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PropertyVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfPropertyVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfPropertyVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfPropertyVO {
    items: PropertyVO[] | undefined;
}

export class ListResultVOOfReadPropertyValueVO implements IListResultVOOfReadPropertyValueVO {
    items!: ReadPropertyValueVO[] | undefined;

    constructor(data?: IListResultVOOfReadPropertyValueVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ReadPropertyValueVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfReadPropertyValueVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfReadPropertyValueVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfReadPropertyValueVO {
    items: ReadPropertyValueVO[] | undefined;
}

export class ListResultVOOfSettingVO implements IListResultVOOfSettingVO {
    items!: SettingVO[] | undefined;

    constructor(data?: IListResultVOOfSettingVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SettingVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultVOOfSettingVO {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfSettingVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultVOOfSettingVO {
    items: SettingVO[] | undefined;
}

export class ListResultVOOfstring implements IListResultVOOfstring {
    items!: string[] | undefined;

    constructor(data?: IListResultVOOfstring) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(item);
            }
        }
    }

    static fromJS(data: any): ListResultVOOfstring {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultVOOfstring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data; 
    }
}

export interface IListResultVOOfstring {
    items: string[] | undefined;
}

export class MethodParamDTO implements IMethodParamDTO {
    /** 网关应用编号 */
    appCode!: number | undefined;
    /** 应用方法编号 */
    code!: number | undefined;
    /** 网关SN */
    gatewayCode!: string | undefined;

    constructor(data?: IMethodParamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.code = data["code"];
            this.gatewayCode = data["gatewayCode"];
        }
    }

    static fromJS(data: any): MethodParamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MethodParamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["code"] = this.code;
        data["gatewayCode"] = this.gatewayCode;
        return data; 
    }
}

export interface IMethodParamDTO {
    /** 网关应用编号 */
    appCode: number | undefined;
    /** 应用方法编号 */
    code: number | undefined;
    /** 网关SN */
    gatewayCode: string | undefined;
}

export class MethodParamVO implements IMethodParamVO {
    /** 方法参数描述 */
    description!: string | undefined;
    /** 方法参数名称 */
    name!: string | undefined;
    /** 方法参数类型 */
    type!: string | undefined;

    constructor(data?: IMethodParamVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.name = data["name"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): MethodParamVO {
        data = typeof data === 'object' ? data : {};
        let result = new MethodParamVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }
}

export interface IMethodParamVO {
    /** 方法参数描述 */
    description: string | undefined;
    /** 方法参数名称 */
    name: string | undefined;
    /** 方法参数类型 */
    type: string | undefined;
}

export class MethodVO implements IMethodVO {
    /** 方法编号 */
    code!: number | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 所属网关编号 */
    gatewayCode!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 所属应用编号 */
    iotAppCode!: number | undefined;
    /** 方法名称 */
    name!: string | undefined;
    /** 返回类型 */
    returnType!: string | undefined;

    constructor(data?: IMethodVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.description = data["description"];
            this.gatewayCode = data["gatewayCode"];
            this.id = data["id"];
            this.iotAppCode = data["iotAppCode"];
            this.name = data["name"];
            this.returnType = data["returnType"];
        }
    }

    static fromJS(data: any): MethodVO {
        data = typeof data === 'object' ? data : {};
        let result = new MethodVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["gatewayCode"] = this.gatewayCode;
        data["id"] = this.id;
        data["iotAppCode"] = this.iotAppCode;
        data["name"] = this.name;
        data["returnType"] = this.returnType;
        return data; 
    }
}

export interface IMethodVO {
    /** 方法编号 */
    code: number | undefined;
    /** 描述 */
    description: string | undefined;
    /** 所属网关编号 */
    gatewayCode: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 所属应用编号 */
    iotAppCode: number | undefined;
    /** 方法名称 */
    name: string | undefined;
    /** 返回类型 */
    returnType: string | undefined;
}

export class ModelTemplateBriefVO implements IModelTemplateBriefVO {
    /** 适用的驱动类型 */
    driverType!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 模板名称 */
    name!: string | undefined;

    constructor(data?: IModelTemplateBriefVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.driverType = data["driverType"];
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ModelTemplateBriefVO {
        data = typeof data === 'object' ? data : {};
        let result = new ModelTemplateBriefVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driverType"] = this.driverType;
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IModelTemplateBriefVO {
    /** 适用的驱动类型 */
    driverType: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 模板名称 */
    name: string | undefined;
}

export class ModelTemplateDetailVO implements IModelTemplateDetailVO {
    /** 采集项(属性) */
    collectionItemList!: CollectionItem[] | undefined;
    /** 适用的驱动类型 */
    driverType!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 模板名称 */
    name!: string | undefined;
    /** 设置项，key是设置名称，value是当前值 */
    settingItem!: { [key: string] : string; } | undefined;

    constructor(data?: IModelTemplateDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["collectionItemList"] && data["collectionItemList"].constructor === Array) {
                this.collectionItemList = [] as any;
                for (let item of data["collectionItemList"])
                    this.collectionItemList!.push(CollectionItem.fromJS(item));
            }
            this.driverType = data["driverType"];
            this.id = data["id"];
            this.name = data["name"];
            if (data["settingItem"]) {
                this.settingItem = {} as any;
                for (let key in data["settingItem"]) {
                    if (data["settingItem"].hasOwnProperty(key))
                        this.settingItem![key] = data["settingItem"][key];
                }
            }
        }
    }

    static fromJS(data: any): ModelTemplateDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new ModelTemplateDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.collectionItemList && this.collectionItemList.constructor === Array) {
            data["collectionItemList"] = [];
            for (let item of this.collectionItemList)
                data["collectionItemList"].push(item.toJSON());
        }
        data["driverType"] = this.driverType;
        data["id"] = this.id;
        data["name"] = this.name;
        if (this.settingItem) {
            data["settingItem"] = {};
            for (let key in this.settingItem) {
                if (this.settingItem.hasOwnProperty(key))
                    data["settingItem"][key] = this.settingItem[key];
            }
        }
        return data; 
    }
}

export interface IModelTemplateDetailVO {
    /** 采集项(属性) */
    collectionItemList: CollectionItem[] | undefined;
    /** 适用的驱动类型 */
    driverType: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 模板名称 */
    name: string | undefined;
    /** 设置项，key是设置名称，value是当前值 */
    settingItem: { [key: string] : string; } | undefined;
}

export class NotOnlineGatewayDTO implements INotOnlineGatewayDTO {
    ascs!: string | undefined;
    current!: number | undefined;
    /** 多少天没上线 */
    days!: string | undefined;
    descs!: string | undefined;
    filter!: string | undefined;
    size!: number | undefined;

    constructor(data?: INotOnlineGatewayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ascs = data["ascs"];
            this.current = data["current"];
            this.days = data["days"];
            this.descs = data["descs"];
            this.filter = data["filter"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): NotOnlineGatewayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotOnlineGatewayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ascs"] = this.ascs;
        data["current"] = this.current;
        data["days"] = this.days;
        data["descs"] = this.descs;
        data["filter"] = this.filter;
        data["size"] = this.size;
        return data; 
    }
}

export interface INotOnlineGatewayDTO {
    ascs: string | undefined;
    current: number | undefined;
    /** 多少天没上线 */
    days: string | undefined;
    descs: string | undefined;
    filter: string | undefined;
    size: number | undefined;
}

export class OverDateCountDto implements IOverDateCountDto {
    count!: string | undefined;
    tenantId!: string | undefined;
    tenantName!: string | undefined;

    constructor(data?: IOverDateCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.count = data["count"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
        }
    }

    static fromJS(data: any): OverDateCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverDateCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        return data; 
    }
}

export interface IOverDateCountDto {
    count: string | undefined;
    tenantId: string | undefined;
    tenantName: string | undefined;
}

export class OverDateVo implements IOverDateVo {
    tenantId!: string | undefined;
    type!: number | undefined;

    constructor(data?: IOverDateVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): OverDateVo {
        data = typeof data === 'object' ? data : {};
        let result = new OverDateVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["type"] = this.type;
        return data; 
    }
}

export interface IOverDateVo {
    tenantId: string | undefined;
    type: number | undefined;
}

export class PageFirmwareDTO implements IPageFirmwareDTO {
    ascs!: string | undefined;
    current!: number | undefined;
    descs!: string | undefined;
    /** 固件(文件)名称 */
    fileName!: string | undefined;
    filter!: string | undefined;
    size!: number | undefined;
    /** 租户id */
    tenantId!: string | undefined;
    /** 固件版本 */
    version!: string | undefined;

    constructor(data?: IPageFirmwareDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ascs = data["ascs"];
            this.current = data["current"];
            this.descs = data["descs"];
            this.fileName = data["fileName"];
            this.filter = data["filter"];
            this.size = data["size"];
            this.tenantId = data["tenantId"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): PageFirmwareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageFirmwareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ascs"] = this.ascs;
        data["current"] = this.current;
        data["descs"] = this.descs;
        data["fileName"] = this.fileName;
        data["filter"] = this.filter;
        data["size"] = this.size;
        data["tenantId"] = this.tenantId;
        data["version"] = this.version;
        return data; 
    }
}

export interface IPageFirmwareDTO {
    ascs: string | undefined;
    current: number | undefined;
    descs: string | undefined;
    /** 固件(文件)名称 */
    fileName: string | undefined;
    filter: string | undefined;
    size: number | undefined;
    /** 租户id */
    tenantId: string | undefined;
    /** 固件版本 */
    version: string | undefined;
}

export class PageFirmwareLogDTO implements IPageFirmwareLogDTO {
    ascs!: string | undefined;
    current!: number | undefined;
    descs!: string | undefined;
    filter!: string | undefined;
    /** 固件名称 */
    firmwareName!: string | undefined;
    /** 网关Code */
    gatewayCode!: string | undefined;
    size!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: IPageFirmwareLogDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ascs = data["ascs"];
            this.current = data["current"];
            this.descs = data["descs"];
            this.filter = data["filter"];
            this.firmwareName = data["firmwareName"];
            this.gatewayCode = data["gatewayCode"];
            this.size = data["size"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): PageFirmwareLogDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageFirmwareLogDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ascs"] = this.ascs;
        data["current"] = this.current;
        data["descs"] = this.descs;
        data["filter"] = this.filter;
        data["firmwareName"] = this.firmwareName;
        data["gatewayCode"] = this.gatewayCode;
        data["size"] = this.size;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IPageFirmwareLogDTO {
    ascs: string | undefined;
    current: number | undefined;
    descs: string | undefined;
    filter: string | undefined;
    /** 固件名称 */
    firmwareName: string | undefined;
    /** 网关Code */
    gatewayCode: string | undefined;
    size: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class PageGatewayDTO implements IPageGatewayDTO {
    ascs!: string | undefined;
    /** 批次号 */
    batchCode!: string | undefined;
    current!: number | undefined;
    descs!: string | undefined;
    filter!: string | undefined;
    /** 是否已绑定工位 */
    hasWorkStation!: boolean | undefined;
    /** 是否在线 */
    isOnline!: boolean | undefined;
    size!: number | undefined;
    /** 租户code */
    tenantId!: string | undefined;
    /** 过滤条件:workStationId */
    workStationIdPattern!: string | undefined;

    constructor(data?: IPageGatewayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ascs = data["ascs"];
            this.batchCode = data["batchCode"];
            this.current = data["current"];
            this.descs = data["descs"];
            this.filter = data["filter"];
            this.hasWorkStation = data["hasWorkStation"];
            this.isOnline = data["isOnline"];
            this.size = data["size"];
            this.tenantId = data["tenantId"];
            this.workStationIdPattern = data["workStationIdPattern"];
        }
    }

    static fromJS(data: any): PageGatewayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageGatewayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ascs"] = this.ascs;
        data["batchCode"] = this.batchCode;
        data["current"] = this.current;
        data["descs"] = this.descs;
        data["filter"] = this.filter;
        data["hasWorkStation"] = this.hasWorkStation;
        data["isOnline"] = this.isOnline;
        data["size"] = this.size;
        data["tenantId"] = this.tenantId;
        data["workStationIdPattern"] = this.workStationIdPattern;
        return data; 
    }
}

export interface IPageGatewayDTO {
    ascs: string | undefined;
    /** 批次号 */
    batchCode: string | undefined;
    current: number | undefined;
    descs: string | undefined;
    filter: string | undefined;
    /** 是否已绑定工位 */
    hasWorkStation: boolean | undefined;
    /** 是否在线 */
    isOnline: boolean | undefined;
    size: number | undefined;
    /** 租户code */
    tenantId: string | undefined;
    /** 过滤条件:workStationId */
    workStationIdPattern: string | undefined;
}

export class PageIotAppCommunicationHistoryDTO implements IPageIotAppCommunicationHistoryDTO {
    /** 网关应用编号 */
    appCode!: number | undefined;
    /** 网关SN */
    gatewayCode!: string | undefined;
    pageIndex!: number | undefined;
    pageSize!: number | undefined;

    constructor(data?: IPageIotAppCommunicationHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.gatewayCode = data["gatewayCode"];
            this.pageIndex = data["pageIndex"];
            this.pageSize = data["pageSize"];
        }
    }

    static fromJS(data: any): PageIotAppCommunicationHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageIotAppCommunicationHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["gatewayCode"] = this.gatewayCode;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data; 
    }
}

export interface IPageIotAppCommunicationHistoryDTO {
    /** 网关应用编号 */
    appCode: number | undefined;
    /** 网关SN */
    gatewayCode: string | undefined;
    pageIndex: number | undefined;
    pageSize: number | undefined;
}

export class PageProductBatchDTO implements IPageProductBatchDTO {
    ascs!: string | undefined;
    current!: number | undefined;
    descs!: string | undefined;
    filter!: string | undefined;
    size!: number | undefined;
    /** 租户code */
    tenantId!: string | undefined;

    constructor(data?: IPageProductBatchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ascs = data["ascs"];
            this.current = data["current"];
            this.descs = data["descs"];
            this.filter = data["filter"];
            this.size = data["size"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): PageProductBatchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageProductBatchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ascs"] = this.ascs;
        data["current"] = this.current;
        data["descs"] = this.descs;
        data["filter"] = this.filter;
        data["size"] = this.size;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IPageProductBatchDTO {
    ascs: string | undefined;
    current: number | undefined;
    descs: string | undefined;
    filter: string | undefined;
    size: number | undefined;
    /** 租户code */
    tenantId: string | undefined;
}

export class PageRequestDTO implements IPageRequestDTO {
    ascs!: string | undefined;
    current!: number | undefined;
    descs!: string | undefined;
    filter!: string | undefined;
    size!: number | undefined;

    constructor(data?: IPageRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ascs = data["ascs"];
            this.current = data["current"];
            this.descs = data["descs"];
            this.filter = data["filter"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): PageRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ascs"] = this.ascs;
        data["current"] = this.current;
        data["descs"] = this.descs;
        data["filter"] = this.filter;
        data["size"] = this.size;
        return data; 
    }
}

export interface IPageRequestDTO {
    ascs: string | undefined;
    current: number | undefined;
    descs: string | undefined;
    filter: string | undefined;
    size: number | undefined;
}

export class PagedResultVOOfCommunicationInfoVO implements IPagedResultVOOfCommunicationInfoVO {
    items!: CommunicationInfoVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfCommunicationInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CommunicationInfoVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfCommunicationInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfCommunicationInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfCommunicationInfoVO {
    items: CommunicationInfoVO[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfFirmwareIssueResultVO implements IPagedResultVOOfFirmwareIssueResultVO {
    items!: FirmwareIssueResultVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfFirmwareIssueResultVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FirmwareIssueResultVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfFirmwareIssueResultVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfFirmwareIssueResultVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfFirmwareIssueResultVO {
    items: FirmwareIssueResultVO[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfFirmwareVO implements IPagedResultVOOfFirmwareVO {
    items!: FirmwareVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfFirmwareVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FirmwareVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfFirmwareVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfFirmwareVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfFirmwareVO {
    items: FirmwareVO[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfGatewayBriefVO implements IPagedResultVOOfGatewayBriefVO {
    items!: GatewayBriefVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfGatewayBriefVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GatewayBriefVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfGatewayBriefVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfGatewayBriefVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfGatewayBriefVO {
    items: GatewayBriefVO[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfGatewayVO implements IPagedResultVOOfGatewayVO {
    items!: GatewayVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfGatewayVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GatewayVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfGatewayVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfGatewayVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfGatewayVO {
    items: GatewayVO[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfIotAbnormalConnectionVO implements IPagedResultVOOfIotAbnormalConnectionVO {
    items!: IotAbnormalConnectionVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfIotAbnormalConnectionVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(IotAbnormalConnectionVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfIotAbnormalConnectionVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfIotAbnormalConnectionVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfIotAbnormalConnectionVO {
    items: IotAbnormalConnectionVO[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfModelTemplateDetailVO implements IPagedResultVOOfModelTemplateDetailVO {
    items!: ModelTemplateDetailVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfModelTemplateDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ModelTemplateDetailVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfModelTemplateDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfModelTemplateDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfModelTemplateDetailVO {
    items: ModelTemplateDetailVO[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfProductBatchVO implements IPagedResultVOOfProductBatchVO {
    items!: ProductBatchVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfProductBatchVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ProductBatchVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfProductBatchVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfProductBatchVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfProductBatchVO {
    items: ProductBatchVO[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfPropertyListVO implements IPagedResultVOOfPropertyListVO {
    items!: PropertyListVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfPropertyListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PropertyListVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfPropertyListVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfPropertyListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfPropertyListVO {
    items: PropertyListVO[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfTransferRecordVO implements IPagedResultVOOfTransferRecordVO {
    list!: TransferRecordVO[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfTransferRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(TransferRecordVO.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfTransferRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfTransferRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfTransferRecordVO {
    list: TransferRecordVO[] | undefined;
    totalCount: number | undefined;
}

export class ProductBatchVO implements IProductBatchVO {
    /** 激活码 */
    activateKey!: string | undefined;
    /** 允许连接数 */
    allowConnectionCount!: number | undefined;
    /** 批次号 */
    batchNo!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 创建人姓名 */
    createUserName!: string | undefined;
    /** 已发货数 */
    deliveredQuantity!: number | undefined;
    /** 硬件类型 */
    hardwareType!: string;
    /** IOTHUB id */
    hubAddress!: string | undefined;
    /** iothub 网关端口 */
    hubGatewayPort!: string | undefined;
    /** IOTHUB id */
    hubId!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** iothub host */
    iothubHost!: string | undefined;
    /** iothub 端口 */
    iothubPort!: number | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型 */
    productType!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 生产总量 */
    totalQuantity!: number | undefined;

    constructor(data?: IProductBatchVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activateKey = data["activateKey"];
            this.allowConnectionCount = data["allowConnectionCount"];
            this.batchNo = data["batchNo"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.createUserName = data["createUserName"];
            this.deliveredQuantity = data["deliveredQuantity"];
            this.hardwareType = data["hardwareType"];
            this.hubAddress = data["hubAddress"];
            this.hubGatewayPort = data["hubGatewayPort"];
            this.hubId = data["hubId"];
            this.id = data["id"];
            this.iothubHost = data["iothubHost"];
            this.iothubPort = data["iothubPort"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.productType = data["productType"];
            this.remark = data["remark"];
            this.tenantId = data["tenantId"];
            this.totalQuantity = data["totalQuantity"];
        }
    }

    static fromJS(data: any): ProductBatchVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductBatchVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activateKey"] = this.activateKey;
        data["allowConnectionCount"] = this.allowConnectionCount;
        data["batchNo"] = this.batchNo;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["createUserName"] = this.createUserName;
        data["deliveredQuantity"] = this.deliveredQuantity;
        data["hardwareType"] = this.hardwareType;
        data["hubAddress"] = this.hubAddress;
        data["hubGatewayPort"] = this.hubGatewayPort;
        data["hubId"] = this.hubId;
        data["id"] = this.id;
        data["iothubHost"] = this.iothubHost;
        data["iothubPort"] = this.iothubPort;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        data["remark"] = this.remark;
        data["tenantId"] = this.tenantId;
        data["totalQuantity"] = this.totalQuantity;
        return data; 
    }
}

export interface IProductBatchVO {
    /** 激活码 */
    activateKey: string | undefined;
    /** 允许连接数 */
    allowConnectionCount: number | undefined;
    /** 批次号 */
    batchNo: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 创建人姓名 */
    createUserName: string | undefined;
    /** 已发货数 */
    deliveredQuantity: number | undefined;
    /** 硬件类型 */
    hardwareType: string;
    /** IOTHUB id */
    hubAddress: string | undefined;
    /** iothub 网关端口 */
    hubGatewayPort: string | undefined;
    /** IOTHUB id */
    hubId: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** iothub host */
    iothubHost: string | undefined;
    /** iothub 端口 */
    iothubPort: number | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型 */
    productType: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 生产总量 */
    totalQuantity: number | undefined;
}

export class PropertyDataBO implements IPropertyDataBO {
    iotAppId!: string | undefined;
    name!: string | undefined;
    reportTime!: Date | undefined;
    value!: string | undefined;

    constructor(data?: IPropertyDataBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.iotAppId = data["iotAppId"];
            this.name = data["name"];
            this.reportTime = data["reportTime"] ? new Date(data["reportTime"].toString()) : <any>undefined;
            this.value = data["value"];
        }
    }

    static fromJS(data: any): PropertyDataBO {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDataBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iotAppId"] = this.iotAppId;
        data["name"] = this.name;
        data["reportTime"] = this.reportTime ? this.reportTime.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data; 
    }
}

export interface IPropertyDataBO {
    iotAppId: string | undefined;
    name: string | undefined;
    reportTime: Date | undefined;
    value: string | undefined;
}

export class PropertyDataDTO implements IPropertyDataDTO {
    beginTime!: string | undefined;
    endTime!: string | undefined;
    keyList!: string[] | undefined;
    nameList!: string[] | undefined;

    constructor(data?: IPropertyDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beginTime = data["beginTime"];
            this.endTime = data["endTime"];
            if (data["keyList"] && data["keyList"].constructor === Array) {
                this.keyList = [] as any;
                for (let item of data["keyList"])
                    this.keyList!.push(item);
            }
            if (data["nameList"] && data["nameList"].constructor === Array) {
                this.nameList = [] as any;
                for (let item of data["nameList"])
                    this.nameList!.push(item);
            }
        }
    }

    static fromJS(data: any): PropertyDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginTime"] = this.beginTime;
        data["endTime"] = this.endTime;
        if (this.keyList && this.keyList.constructor === Array) {
            data["keyList"] = [];
            for (let item of this.keyList)
                data["keyList"].push(item);
        }
        if (this.nameList && this.nameList.constructor === Array) {
            data["nameList"] = [];
            for (let item of this.nameList)
                data["nameList"].push(item);
        }
        return data; 
    }
}

export interface IPropertyDataDTO {
    beginTime: string | undefined;
    endTime: string | undefined;
    keyList: string[] | undefined;
    nameList: string[] | undefined;
}

export class PropertyLatestDataBO implements IPropertyLatestDataBO {
    appCode!: number | undefined;
    dataStatus!: number | undefined;
    gatewayCode!: string | undefined;
    propertyName!: string | undefined;
    propertyValue!: string | undefined;
    reportTime!: string | undefined;

    constructor(data?: IPropertyLatestDataBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.dataStatus = data["dataStatus"];
            this.gatewayCode = data["gatewayCode"];
            this.propertyName = data["propertyName"];
            this.propertyValue = data["propertyValue"];
            this.reportTime = data["reportTime"];
        }
    }

    static fromJS(data: any): PropertyLatestDataBO {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyLatestDataBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["dataStatus"] = this.dataStatus;
        data["gatewayCode"] = this.gatewayCode;
        data["propertyName"] = this.propertyName;
        data["propertyValue"] = this.propertyValue;
        data["reportTime"] = this.reportTime;
        return data; 
    }
}

export interface IPropertyLatestDataBO {
    appCode: number | undefined;
    dataStatus: number | undefined;
    gatewayCode: string | undefined;
    propertyName: string | undefined;
    propertyValue: string | undefined;
    reportTime: string | undefined;
}

export class PropertyListVO implements IPropertyListVO {
    /** io地址参数 */
    addressParam!: string | undefined;
    /** 属性编号 */
    code!: number | undefined;
    /** 当前值 */
    currentValue!: string | undefined;
    /** 默认值 */
    defaultValue!: string | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 值倍率 */
    factor!: number | undefined;
    /** 所属网关编号 */
    gatewayCode!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    ioAddress!: string | undefined;
    /** io地址 */
    ioAddressPrefix!: string | undefined;
    /** 所属应用编号 */
    iotAppCode!: number | undefined;
    /** 是否生效 */
    isTakeEffected!: number | undefined;
    /** 属性名称 */
    name!: string | undefined;
    nameIsError!: boolean | undefined;
    notAllowChar!: string | undefined;
    /** 数据类型 */
    type!: string | undefined;

    constructor(data?: IPropertyListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.addressParam = data["addressParam"];
            this.code = data["code"];
            this.currentValue = data["currentValue"];
            this.defaultValue = data["defaultValue"];
            this.description = data["description"];
            this.factor = data["factor"];
            this.gatewayCode = data["gatewayCode"];
            this.id = data["id"];
            this.ioAddress = data["ioAddress"];
            this.ioAddressPrefix = data["ioAddressPrefix"];
            this.iotAppCode = data["iotAppCode"];
            this.isTakeEffected = data["isTakeEffected"];
            this.name = data["name"];
            this.nameIsError = data["nameIsError"];
            this.notAllowChar = data["notAllowChar"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): PropertyListVO {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressParam"] = this.addressParam;
        data["code"] = this.code;
        data["currentValue"] = this.currentValue;
        data["defaultValue"] = this.defaultValue;
        data["description"] = this.description;
        data["factor"] = this.factor;
        data["gatewayCode"] = this.gatewayCode;
        data["id"] = this.id;
        data["ioAddress"] = this.ioAddress;
        data["ioAddressPrefix"] = this.ioAddressPrefix;
        data["iotAppCode"] = this.iotAppCode;
        data["isTakeEffected"] = this.isTakeEffected;
        data["name"] = this.name;
        data["nameIsError"] = this.nameIsError;
        data["notAllowChar"] = this.notAllowChar;
        data["type"] = this.type;
        return data; 
    }
}

export interface IPropertyListVO {
    /** io地址参数 */
    addressParam: string | undefined;
    /** 属性编号 */
    code: number | undefined;
    /** 当前值 */
    currentValue: string | undefined;
    /** 默认值 */
    defaultValue: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 值倍率 */
    factor: number | undefined;
    /** 所属网关编号 */
    gatewayCode: string | undefined;
    /** 主键id */
    id: string | undefined;
    ioAddress: string | undefined;
    /** io地址 */
    ioAddressPrefix: string | undefined;
    /** 所属应用编号 */
    iotAppCode: number | undefined;
    /** 是否生效 */
    isTakeEffected: number | undefined;
    /** 属性名称 */
    name: string | undefined;
    nameIsError: boolean | undefined;
    notAllowChar: string | undefined;
    /** 数据类型 */
    type: string | undefined;
}

export class PropertyVO implements IPropertyVO {
    /** io地址参数 */
    addressParam!: string | undefined;
    /** 属性编号 */
    code!: number | undefined;
    /** 当前值 */
    currentValue!: string | undefined;
    /** 默认值 */
    defaultValue!: string | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 值倍率 */
    factor!: number | undefined;
    /** 所属网关编号 */
    gatewayCode!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    ioAddress!: string | undefined;
    /** io地址 */
    ioAddressPrefix!: string | undefined;
    /** 所属应用编号 */
    iotAppCode!: number | undefined;
    /** 是否生效 */
    isTakeEffected!: number | undefined;
    /** 属性名称 */
    name!: string | undefined;
    /** 数据类型 */
    type!: string | undefined;

    constructor(data?: IPropertyVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.addressParam = data["addressParam"];
            this.code = data["code"];
            this.currentValue = data["currentValue"];
            this.defaultValue = data["defaultValue"];
            this.description = data["description"];
            this.factor = data["factor"];
            this.gatewayCode = data["gatewayCode"];
            this.id = data["id"];
            this.ioAddress = data["ioAddress"];
            this.ioAddressPrefix = data["ioAddressPrefix"];
            this.iotAppCode = data["iotAppCode"];
            this.isTakeEffected = data["isTakeEffected"];
            this.name = data["name"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): PropertyVO {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressParam"] = this.addressParam;
        data["code"] = this.code;
        data["currentValue"] = this.currentValue;
        data["defaultValue"] = this.defaultValue;
        data["description"] = this.description;
        data["factor"] = this.factor;
        data["gatewayCode"] = this.gatewayCode;
        data["id"] = this.id;
        data["ioAddress"] = this.ioAddress;
        data["ioAddressPrefix"] = this.ioAddressPrefix;
        data["iotAppCode"] = this.iotAppCode;
        data["isTakeEffected"] = this.isTakeEffected;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }
}

export interface IPropertyVO {
    /** io地址参数 */
    addressParam: string | undefined;
    /** 属性编号 */
    code: number | undefined;
    /** 当前值 */
    currentValue: string | undefined;
    /** 默认值 */
    defaultValue: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 值倍率 */
    factor: number | undefined;
    /** 所属网关编号 */
    gatewayCode: string | undefined;
    /** 主键id */
    id: string | undefined;
    ioAddress: string | undefined;
    /** io地址 */
    ioAddressPrefix: string | undefined;
    /** 所属应用编号 */
    iotAppCode: number | undefined;
    /** 是否生效 */
    isTakeEffected: number | undefined;
    /** 属性名称 */
    name: string | undefined;
    /** 数据类型 */
    type: string | undefined;
}

/** 返回信息 */
export class R implements IR {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: any | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IR) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): R {
        data = typeof data === 'object' ? data : {};
        let result = new R();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IR {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: any | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfGatewayVO implements IROfGatewayVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: GatewayVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfGatewayVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? GatewayVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfGatewayVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfGatewayVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfGatewayVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: GatewayVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIotAppVO implements IROfIotAppVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IotAppVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIotAppVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IotAppVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIotAppVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIotAppVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIotAppVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IotAppVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfExtranetAppStatusBO implements IROfListOfExtranetAppStatusBO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: ExtranetAppStatusBO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfExtranetAppStatusBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(ExtranetAppStatusBO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfExtranetAppStatusBO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfExtranetAppStatusBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfExtranetAppStatusBO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: ExtranetAppStatusBO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfGatewayBriefBO implements IROfListOfGatewayBriefBO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: GatewayBriefBO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfGatewayBriefBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(GatewayBriefBO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfGatewayBriefBO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfGatewayBriefBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfGatewayBriefBO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: GatewayBriefBO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfGatewayExportVO implements IROfListOfGatewayExportVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: GatewayExportVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfGatewayExportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(GatewayExportVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfGatewayExportVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfGatewayExportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfGatewayExportVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: GatewayExportVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfGatewayVO implements IROfListOfGatewayVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: GatewayVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfGatewayVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(GatewayVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfGatewayVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfGatewayVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfGatewayVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: GatewayVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfIotAppBriefBO implements IROfListOfIotAppBriefBO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IotAppBriefBO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfIotAppBriefBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(IotAppBriefBO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfIotAppBriefBO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfIotAppBriefBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfIotAppBriefBO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IotAppBriefBO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfIotAppVO implements IROfListOfIotAppVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IotAppVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfIotAppVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(IotAppVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfIotAppVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfIotAppVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfIotAppVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IotAppVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfMethodVO implements IROfListOfMethodVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MethodVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfMethodVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(MethodVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfMethodVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfMethodVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfMethodVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MethodVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfPropertyDataBO implements IROfListOfPropertyDataBO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: PropertyDataBO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfPropertyDataBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(PropertyDataBO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfPropertyDataBO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfPropertyDataBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfPropertyDataBO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: PropertyDataBO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfPropertyLatestDataBO implements IROfListOfPropertyLatestDataBO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: PropertyLatestDataBO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfPropertyLatestDataBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(PropertyLatestDataBO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfPropertyLatestDataBO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfPropertyLatestDataBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfPropertyLatestDataBO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: PropertyLatestDataBO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfPropertyVO implements IROfListOfPropertyVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: PropertyVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfPropertyVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(PropertyVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfPropertyVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfPropertyVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfPropertyVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: PropertyVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfSetOflong implements IROfSetOflong {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: number[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfSetOflong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(item);
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfSetOflong {
        data = typeof data === 'object' ? data : {};
        let result = new ROfSetOflong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfSetOflong {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: number[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfUseAppPropertyTemplateVO implements IROfUseAppPropertyTemplateVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: UseAppPropertyTemplateVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfUseAppPropertyTemplateVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? UseAppPropertyTemplateVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfUseAppPropertyTemplateVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfUseAppPropertyTemplateVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfUseAppPropertyTemplateVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: UseAppPropertyTemplateVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfboolean implements IROfboolean {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: boolean | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfboolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfboolean {
        data = typeof data === 'object' ? data : {};
        let result = new ROfboolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfboolean {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: boolean | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfint implements IROfint {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: number | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfint {
        data = typeof data === 'object' ? data : {};
        let result = new ROfint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfint {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: number | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfobject implements IROfobject {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: any | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfobject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfobject {
        data = typeof data === 'object' ? data : {};
        let result = new ROfobject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfobject {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: any | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfstring implements IROfstring {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: string | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfstring) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfstring {
        data = typeof data === 'object' ? data : {};
        let result = new ROfstring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfstring {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: string | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class ReadPropertyValueDTO implements IReadPropertyValueDTO {
    /** 网关应用编号 */
    appCode!: number | undefined;
    /** 网关SN */
    gatewayCode!: string | undefined;
    propertyCodeList!: number[] | undefined;

    constructor(data?: IReadPropertyValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.gatewayCode = data["gatewayCode"];
            if (data["propertyCodeList"] && data["propertyCodeList"].constructor === Array) {
                this.propertyCodeList = [] as any;
                for (let item of data["propertyCodeList"])
                    this.propertyCodeList!.push(item);
            }
        }
    }

    static fromJS(data: any): ReadPropertyValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReadPropertyValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["gatewayCode"] = this.gatewayCode;
        if (this.propertyCodeList && this.propertyCodeList.constructor === Array) {
            data["propertyCodeList"] = [];
            for (let item of this.propertyCodeList)
                data["propertyCodeList"].push(item);
        }
        return data; 
    }
}

export interface IReadPropertyValueDTO {
    /** 网关应用编号 */
    appCode: number | undefined;
    /** 网关SN */
    gatewayCode: string | undefined;
    propertyCodeList: number[] | undefined;
}

export class ReadPropertyValueVO implements IReadPropertyValueVO {
    dataType!: number | undefined;
    propertyCode!: number | undefined;
    propertyValue!: string | undefined;
    valueStatus!: number | undefined;

    constructor(data?: IReadPropertyValueVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataType = data["dataType"];
            this.propertyCode = data["propertyCode"];
            this.propertyValue = data["propertyValue"];
            this.valueStatus = data["valueStatus"];
        }
    }

    static fromJS(data: any): ReadPropertyValueVO {
        data = typeof data === 'object' ? data : {};
        let result = new ReadPropertyValueVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataType"] = this.dataType;
        data["propertyCode"] = this.propertyCode;
        data["propertyValue"] = this.propertyValue;
        data["valueStatus"] = this.valueStatus;
        return data; 
    }
}

export interface IReadPropertyValueVO {
    dataType: number | undefined;
    propertyCode: number | undefined;
    propertyValue: string | undefined;
    valueStatus: number | undefined;
}

export class RecycleGatewayDTO implements IRecycleGatewayDTO {
    /** 回收的网关id列表 */
    gatewayIdList!: string[] | undefined;
    /** 回收的网关所属租户 */
    targetTenantName!: string | undefined;

    constructor(data?: IRecycleGatewayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["gatewayIdList"] && data["gatewayIdList"].constructor === Array) {
                this.gatewayIdList = [] as any;
                for (let item of data["gatewayIdList"])
                    this.gatewayIdList!.push(item);
            }
            this.targetTenantName = data["targetTenantName"];
        }
    }

    static fromJS(data: any): RecycleGatewayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecycleGatewayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.gatewayIdList && this.gatewayIdList.constructor === Array) {
            data["gatewayIdList"] = [];
            for (let item of this.gatewayIdList)
                data["gatewayIdList"].push(item);
        }
        data["targetTenantName"] = this.targetTenantName;
        return data; 
    }
}

export interface IRecycleGatewayDTO {
    /** 回收的网关id列表 */
    gatewayIdList: string[] | undefined;
    /** 回收的网关所属租户 */
    targetTenantName: string | undefined;
}

export class RegisterGatewayDTO implements IRegisterGatewayDTO {
    /** 批次号 */
    batchNo!: string;
    /** 名称[别名] */
    name!: string | undefined;
    /** 本次登记数量 */
    registerCount!: number;

    constructor(data?: IRegisterGatewayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchNo = data["batchNo"];
            this.name = data["name"];
            this.registerCount = data["registerCount"];
        }
    }

    static fromJS(data: any): RegisterGatewayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterGatewayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNo"] = this.batchNo;
        data["name"] = this.name;
        data["registerCount"] = this.registerCount;
        return data; 
    }
}

export interface IRegisterGatewayDTO {
    /** 批次号 */
    batchNo: string;
    /** 名称[别名] */
    name: string | undefined;
    /** 本次登记数量 */
    registerCount: number;
}

export class RequestMetadataDto implements IRequestMetadataDto {
    appCode!: number | undefined;
    gatewayCode!: string | undefined;

    constructor(data?: IRequestMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.gatewayCode = data["gatewayCode"];
        }
    }

    static fromJS(data: any): RequestMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["gatewayCode"] = this.gatewayCode;
        return data; 
    }
}

export interface IRequestMetadataDto {
    appCode: number | undefined;
    gatewayCode: string | undefined;
}

export class SaveIotAppSettingDTO implements ISaveIotAppSettingDTO {
    /** 网关SN */
    gatewayCode!: string | undefined;
    /** 网关app编号 */
    iotAppCode!: number | undefined;
    settingData!: { [key: string] : any; } | undefined;

    constructor(data?: ISaveIotAppSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.iotAppCode = data["iotAppCode"];
            if (data["settingData"]) {
                this.settingData = {} as any;
                for (let key in data["settingData"]) {
                    if (data["settingData"].hasOwnProperty(key))
                        this.settingData![key] = data["settingData"][key];
                }
            }
        }
    }

    static fromJS(data: any): SaveIotAppSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveIotAppSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["iotAppCode"] = this.iotAppCode;
        if (this.settingData) {
            data["settingData"] = {};
            for (let key in this.settingData) {
                if (this.settingData.hasOwnProperty(key))
                    data["settingData"][key] = this.settingData[key];
            }
        }
        return data; 
    }
}

export interface ISaveIotAppSettingDTO {
    /** 网关SN */
    gatewayCode: string | undefined;
    /** 网关app编号 */
    iotAppCode: number | undefined;
    settingData: { [key: string] : any; } | undefined;
}

export class ServerStopDTO implements IServerStopDTO {
    /** 网关编号 */
    gatewayCode!: string | undefined;
    /** 服务名 */
    serverName!: string | undefined;

    constructor(data?: IServerStopDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.serverName = data["serverName"];
        }
    }

    static fromJS(data: any): ServerStopDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServerStopDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["serverName"] = this.serverName;
        return data; 
    }
}

export interface IServerStopDTO {
    /** 网关编号 */
    gatewayCode: string | undefined;
    /** 服务名 */
    serverName: string | undefined;
}

export class SettingVO implements ISettingVO {
    /** 设置项编号 */
    code!: number | undefined;
    /** 当前值 */
    currentValue!: string | undefined;
    /** 数据类型 */
    dataType!: string | undefined;
    /** 默认值 */
    defaultValue!: string | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 预期值 */
    expectedValue!: string | undefined;
    /** 所属网关编号 */
    gatewayCode!: string | undefined;
    /** 所属应用编号 */
    iotAppCode!: number | undefined;
    /** 设置项名称 */
    name!: string | undefined;

    constructor(data?: ISettingVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.currentValue = data["currentValue"];
            this.dataType = data["dataType"];
            this.defaultValue = data["defaultValue"];
            this.description = data["description"];
            this.expectedValue = data["expectedValue"];
            this.gatewayCode = data["gatewayCode"];
            this.iotAppCode = data["iotAppCode"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SettingVO {
        data = typeof data === 'object' ? data : {};
        let result = new SettingVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["currentValue"] = this.currentValue;
        data["dataType"] = this.dataType;
        data["defaultValue"] = this.defaultValue;
        data["description"] = this.description;
        data["expectedValue"] = this.expectedValue;
        data["gatewayCode"] = this.gatewayCode;
        data["iotAppCode"] = this.iotAppCode;
        data["name"] = this.name;
        return data; 
    }
}

export interface ISettingVO {
    /** 设置项编号 */
    code: number | undefined;
    /** 当前值 */
    currentValue: string | undefined;
    /** 数据类型 */
    dataType: string | undefined;
    /** 默认值 */
    defaultValue: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 预期值 */
    expectedValue: string | undefined;
    /** 所属网关编号 */
    gatewayCode: string | undefined;
    /** 所属应用编号 */
    iotAppCode: number | undefined;
    /** 设置项名称 */
    name: string | undefined;
}

export class StatisticsGatewayVO implements IStatisticsGatewayVO {
    /** 从未上线数量 */
    neverOnline!: number | undefined;
    /** 离线数量 */
    offline!: number | undefined;
    /** 在线数量 */
    online!: number | undefined;
    /** 总数量 */
    total!: number | undefined;

    constructor(data?: IStatisticsGatewayVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.neverOnline = data["neverOnline"];
            this.offline = data["offline"];
            this.online = data["online"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): StatisticsGatewayVO {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsGatewayVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["neverOnline"] = this.neverOnline;
        data["offline"] = this.offline;
        data["online"] = this.online;
        data["total"] = this.total;
        return data; 
    }
}

export interface IStatisticsGatewayVO {
    /** 从未上线数量 */
    neverOnline: number | undefined;
    /** 离线数量 */
    offline: number | undefined;
    /** 在线数量 */
    online: number | undefined;
    /** 总数量 */
    total: number | undefined;
}

export class StatisticsIotAbnormalConnectionVO implements IStatisticsIotAbnormalConnectionVO {
    /** 异常连接数量 */
    count!: number | undefined;
    /** 时间片 */
    timeSlice!: string | undefined;

    constructor(data?: IStatisticsIotAbnormalConnectionVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.count = data["count"];
            this.timeSlice = data["timeSlice"];
        }
    }

    static fromJS(data: any): StatisticsIotAbnormalConnectionVO {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsIotAbnormalConnectionVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["timeSlice"] = this.timeSlice;
        return data; 
    }
}

export interface IStatisticsIotAbnormalConnectionVO {
    /** 异常连接数量 */
    count: number | undefined;
    /** 时间片 */
    timeSlice: string | undefined;
}

export class TransferRecordDTO implements ITransferRecordDTO {
    ascs!: string | undefined;
    createUser!: string | undefined;
    createUserName!: string | undefined;
    current!: number | undefined;
    descs!: string | undefined;
    endTime!: string | undefined;
    filter!: string | undefined;
    gatewayCode!: string | undefined;
    newTenantId!: string | undefined;
    oldTenantId!: string | undefined;
    size!: number | undefined;
    startTime!: string | undefined;

    constructor(data?: ITransferRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ascs = data["ascs"];
            this.createUser = data["createUser"];
            this.createUserName = data["createUserName"];
            this.current = data["current"];
            this.descs = data["descs"];
            this.endTime = data["endTime"];
            this.filter = data["filter"];
            this.gatewayCode = data["gatewayCode"];
            this.newTenantId = data["newTenantId"];
            this.oldTenantId = data["oldTenantId"];
            this.size = data["size"];
            this.startTime = data["startTime"];
        }
    }

    static fromJS(data: any): TransferRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TransferRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ascs"] = this.ascs;
        data["createUser"] = this.createUser;
        data["createUserName"] = this.createUserName;
        data["current"] = this.current;
        data["descs"] = this.descs;
        data["endTime"] = this.endTime;
        data["filter"] = this.filter;
        data["gatewayCode"] = this.gatewayCode;
        data["newTenantId"] = this.newTenantId;
        data["oldTenantId"] = this.oldTenantId;
        data["size"] = this.size;
        data["startTime"] = this.startTime;
        return data; 
    }
}

export interface ITransferRecordDTO {
    ascs: string | undefined;
    createUser: string | undefined;
    createUserName: string | undefined;
    current: number | undefined;
    descs: string | undefined;
    endTime: string | undefined;
    filter: string | undefined;
    gatewayCode: string | undefined;
    newTenantId: string | undefined;
    oldTenantId: string | undefined;
    size: number | undefined;
    startTime: string | undefined;
}

export class TransferRecordVO implements ITransferRecordVO {
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人名称 */
    createUserName!: string | undefined;
    /** 网关id */
    gatewayCode!: string | undefined;
    /** 网关编号 */
    gatewayId!: string | undefined;
    /** 新租户编号 */
    newTenantId!: string | undefined;
    /** 新租户名称 */
    newTenantName!: string | undefined;
    /** 原租户编号 */
    oldTenantId!: string | undefined;
    /** 原租户名称 */
    oldTenantName!: string | undefined;

    constructor(data?: ITransferRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUserName = data["createUserName"];
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.newTenantId = data["newTenantId"];
            this.newTenantName = data["newTenantName"];
            this.oldTenantId = data["oldTenantId"];
            this.oldTenantName = data["oldTenantName"];
        }
    }

    static fromJS(data: any): TransferRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new TransferRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUserName"] = this.createUserName;
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["newTenantId"] = this.newTenantId;
        data["newTenantName"] = this.newTenantName;
        data["oldTenantId"] = this.oldTenantId;
        data["oldTenantName"] = this.oldTenantName;
        return data; 
    }
}

export interface ITransferRecordVO {
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人名称 */
    createUserName: string | undefined;
    /** 网关id */
    gatewayCode: string | undefined;
    /** 网关编号 */
    gatewayId: string | undefined;
    /** 新租户编号 */
    newTenantId: string | undefined;
    /** 新租户名称 */
    newTenantName: string | undefined;
    /** 原租户编号 */
    oldTenantId: string | undefined;
    /** 原租户名称 */
    oldTenantName: string | undefined;
}

export class UpdateFirmwareDTO implements IUpdateFirmwareDTO {
    /** 文件id */
    fileId!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** 固件id */
    firmwareId!: string | undefined;
    /** md5签名 */
    md5Code!: string | undefined;
    /** 文件大小 */
    size!: string | undefined;
    /** 文件后缀 */
    suffix!: string | undefined;
    /** 租户ID,多个使用 */
    tenantIds!: string[] | undefined;
    /** 版本 */
    version!: string | undefined;

    constructor(data?: IUpdateFirmwareDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.firmwareId = data["firmwareId"];
            this.md5Code = data["md5Code"];
            this.size = data["size"];
            this.suffix = data["suffix"];
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [] as any;
                for (let item of data["tenantIds"])
                    this.tenantIds!.push(item);
            }
            this.version = data["version"];
        }
    }

    static fromJS(data: any): UpdateFirmwareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFirmwareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["firmwareId"] = this.firmwareId;
        data["md5Code"] = this.md5Code;
        data["size"] = this.size;
        data["suffix"] = this.suffix;
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        data["version"] = this.version;
        return data; 
    }
}

export interface IUpdateFirmwareDTO {
    /** 文件id */
    fileId: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** 固件id */
    firmwareId: string | undefined;
    /** md5签名 */
    md5Code: string | undefined;
    /** 文件大小 */
    size: string | undefined;
    /** 文件后缀 */
    suffix: string | undefined;
    /** 租户ID,多个使用 */
    tenantIds: string[] | undefined;
    /** 版本 */
    version: string | undefined;
}

export class UpdateGatewayDTO implements IUpdateGatewayDTO {
    /** 网关主键id */
    gatewayId!: string | undefined;
    /** 网关名称[描述/备注] */
    name!: string | undefined;

    constructor(data?: IUpdateGatewayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayId = data["gatewayId"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): UpdateGatewayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGatewayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayId"] = this.gatewayId;
        data["name"] = this.name;
        return data; 
    }
}

export interface IUpdateGatewayDTO {
    /** 网关主键id */
    gatewayId: string | undefined;
    /** 网关名称[描述/备注] */
    name: string | undefined;
}

export class UpdateHubDTO implements IUpdateHubDTO {
    /** 域名 */
    host!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 端口 */
    port!: number | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IUpdateHubDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.host = data["host"];
            this.id = data["id"];
            this.port = data["port"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): UpdateHubDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHubDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["host"] = this.host;
        data["id"] = this.id;
        data["port"] = this.port;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IUpdateHubDTO {
    /** 域名 */
    host: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 端口 */
    port: number | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class UpdateIotAppPropertyDTO implements IUpdateIotAppPropertyDTO {
    /** 地址参数 */
    addressParam!: string | undefined;
    /** 网关应用编号 */
    appCode!: number | undefined;
    /** 默认值 */
    defaultValue!: string | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 值倍率 */
    factor!: string | undefined;
    /** 网关SN */
    gatewayCode!: string | undefined;
    /** 属性主键id */
    id!: string | undefined;
    /** io地址 */
    ioAddressPrefix!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 数据类型 */
    type!: string | undefined;

    constructor(data?: IUpdateIotAppPropertyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.addressParam = data["addressParam"];
            this.appCode = data["appCode"];
            this.defaultValue = data["defaultValue"];
            this.description = data["description"];
            this.factor = data["factor"];
            this.gatewayCode = data["gatewayCode"];
            this.id = data["id"];
            this.ioAddressPrefix = data["ioAddressPrefix"];
            this.name = data["name"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): UpdateIotAppPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIotAppPropertyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressParam"] = this.addressParam;
        data["appCode"] = this.appCode;
        data["defaultValue"] = this.defaultValue;
        data["description"] = this.description;
        data["factor"] = this.factor;
        data["gatewayCode"] = this.gatewayCode;
        data["id"] = this.id;
        data["ioAddressPrefix"] = this.ioAddressPrefix;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }
}

export interface IUpdateIotAppPropertyDTO {
    /** 地址参数 */
    addressParam: string | undefined;
    /** 网关应用编号 */
    appCode: number | undefined;
    /** 默认值 */
    defaultValue: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 值倍率 */
    factor: string | undefined;
    /** 网关SN */
    gatewayCode: string | undefined;
    /** 属性主键id */
    id: string | undefined;
    /** io地址 */
    ioAddressPrefix: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 数据类型 */
    type: string | undefined;
}

export class UpdateIotWorkstationAssociateDTO implements IUpdateIotWorkstationAssociateDTO {
    /** 网关编号 */
    gatewayId!: string | undefined;
    /** 所有关联网关的工位信息 */
    workStationBriefInfoList!: WorkStationBriefInfo[] | undefined;

    constructor(data?: IUpdateIotWorkstationAssociateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayId = data["gatewayId"];
            if (data["workStationBriefInfoList"] && data["workStationBriefInfoList"].constructor === Array) {
                this.workStationBriefInfoList = [] as any;
                for (let item of data["workStationBriefInfoList"])
                    this.workStationBriefInfoList!.push(WorkStationBriefInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateIotWorkstationAssociateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIotWorkstationAssociateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayId"] = this.gatewayId;
        if (this.workStationBriefInfoList && this.workStationBriefInfoList.constructor === Array) {
            data["workStationBriefInfoList"] = [];
            for (let item of this.workStationBriefInfoList)
                data["workStationBriefInfoList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateIotWorkstationAssociateDTO {
    /** 网关编号 */
    gatewayId: string | undefined;
    /** 所有关联网关的工位信息 */
    workStationBriefInfoList: WorkStationBriefInfo[] | undefined;
}

export class UpdateProductBatchDTO implements IUpdateProductBatchDTO {
    /** 网关最大授权数 */
    allowConnectionCount!: number;
    /** 批次号 */
    batchNo!: string;
    /** 硬件类型 */
    hardwareType!: string;
    /** IOT地址 */
    hubId!: string;
    /** 产品代码 */
    productCode!: string;
    /** 产品名称 */
    productName!: string;
    /** 产品类型 */
    productType!: number;
    /** 备注 */
    remark!: string | undefined;
    /** 目标租户 */
    tenantId!: string;
    /** 生产批次生产总量 */
    totalQuantity!: number;

    constructor(data?: IUpdateProductBatchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowConnectionCount = data["allowConnectionCount"];
            this.batchNo = data["batchNo"];
            this.hardwareType = data["hardwareType"];
            this.hubId = data["hubId"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.productType = data["productType"];
            this.remark = data["remark"];
            this.tenantId = data["tenantId"];
            this.totalQuantity = data["totalQuantity"];
        }
    }

    static fromJS(data: any): UpdateProductBatchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductBatchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowConnectionCount"] = this.allowConnectionCount;
        data["batchNo"] = this.batchNo;
        data["hardwareType"] = this.hardwareType;
        data["hubId"] = this.hubId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        data["remark"] = this.remark;
        data["tenantId"] = this.tenantId;
        data["totalQuantity"] = this.totalQuantity;
        return data; 
    }
}

export interface IUpdateProductBatchDTO {
    /** 网关最大授权数 */
    allowConnectionCount: number;
    /** 批次号 */
    batchNo: string;
    /** 硬件类型 */
    hardwareType: string;
    /** IOT地址 */
    hubId: string;
    /** 产品代码 */
    productCode: string;
    /** 产品名称 */
    productName: string;
    /** 产品类型 */
    productType: number;
    /** 备注 */
    remark: string | undefined;
    /** 目标租户 */
    tenantId: string;
    /** 生产批次生产总量 */
    totalQuantity: number;
}

export class UpdateTemplateDTO implements IUpdateTemplateDTO {
    /** 模板主键 */
    templateId!: string | undefined;
    /** 模板名称 */
    templateName!: string | undefined;

    constructor(data?: IUpdateTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.templateId = data["templateId"];
            this.templateName = data["templateName"];
        }
    }

    static fromJS(data: any): UpdateTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["templateName"] = this.templateName;
        return data; 
    }
}

export interface IUpdateTemplateDTO {
    /** 模板主键 */
    templateId: string | undefined;
    /** 模板名称 */
    templateName: string | undefined;
}

export class UploadFirmwareDTO implements IUploadFirmwareDTO {
    /** 文件id */
    fileId!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** md5签名 */
    md5Code!: string | undefined;
    /** 文件大小 */
    size!: string | undefined;
    /** 文件后缀 */
    suffix!: string | undefined;
    /** 租户ID,多个使用 */
    tenantIds!: string[] | undefined;
    /** 版本 */
    version!: string | undefined;

    constructor(data?: IUploadFirmwareDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.md5Code = data["md5Code"];
            this.size = data["size"];
            this.suffix = data["suffix"];
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [] as any;
                for (let item of data["tenantIds"])
                    this.tenantIds!.push(item);
            }
            this.version = data["version"];
        }
    }

    static fromJS(data: any): UploadFirmwareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFirmwareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["md5Code"] = this.md5Code;
        data["size"] = this.size;
        data["suffix"] = this.suffix;
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        data["version"] = this.version;
        return data; 
    }
}

export interface IUploadFirmwareDTO {
    /** 文件id */
    fileId: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** md5签名 */
    md5Code: string | undefined;
    /** 文件大小 */
    size: string | undefined;
    /** 文件后缀 */
    suffix: string | undefined;
    /** 租户ID,多个使用 */
    tenantIds: string[] | undefined;
    /** 版本 */
    version: string | undefined;
}

export class UseAppPropertyTemplateDTO implements IUseAppPropertyTemplateDTO {
    appCode!: number | undefined;
    appId!: string | undefined;
    gatewayCode!: string | undefined;
    gatewayId!: string | undefined;
    modelTemplateId!: string | undefined;

    constructor(data?: IUseAppPropertyTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.appId = data["appId"];
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            this.modelTemplateId = data["modelTemplateId"];
        }
    }

    static fromJS(data: any): UseAppPropertyTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UseAppPropertyTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["appId"] = this.appId;
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        data["modelTemplateId"] = this.modelTemplateId;
        return data; 
    }
}

export interface IUseAppPropertyTemplateDTO {
    appCode: number | undefined;
    appId: string | undefined;
    gatewayCode: string | undefined;
    gatewayId: string | undefined;
    modelTemplateId: string | undefined;
}

export class UseAppPropertyTemplateItemVO implements IUseAppPropertyTemplateItemVO {
    propertyId!: string | undefined;
    propertyName!: string | undefined;

    constructor(data?: IUseAppPropertyTemplateItemVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propertyId = data["propertyId"];
            this.propertyName = data["propertyName"];
        }
    }

    static fromJS(data: any): UseAppPropertyTemplateItemVO {
        data = typeof data === 'object' ? data : {};
        let result = new UseAppPropertyTemplateItemVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["propertyName"] = this.propertyName;
        return data; 
    }
}

export interface IUseAppPropertyTemplateItemVO {
    propertyId: string | undefined;
    propertyName: string | undefined;
}

export class UseAppPropertyTemplateVO implements IUseAppPropertyTemplateVO {
    appCode!: number | undefined;
    appId!: string | undefined;
    gatewayCode!: string | undefined;
    gatewayId!: string | undefined;
    itemList!: UseAppPropertyTemplateItemVO[] | undefined;

    constructor(data?: IUseAppPropertyTemplateVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.appId = data["appId"];
            this.gatewayCode = data["gatewayCode"];
            this.gatewayId = data["gatewayId"];
            if (data["itemList"] && data["itemList"].constructor === Array) {
                this.itemList = [] as any;
                for (let item of data["itemList"])
                    this.itemList!.push(UseAppPropertyTemplateItemVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UseAppPropertyTemplateVO {
        data = typeof data === 'object' ? data : {};
        let result = new UseAppPropertyTemplateVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["appId"] = this.appId;
        data["gatewayCode"] = this.gatewayCode;
        data["gatewayId"] = this.gatewayId;
        if (this.itemList && this.itemList.constructor === Array) {
            data["itemList"] = [];
            for (let item of this.itemList)
                data["itemList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUseAppPropertyTemplateVO {
    appCode: number | undefined;
    appId: string | undefined;
    gatewayCode: string | undefined;
    gatewayId: string | undefined;
    itemList: UseAppPropertyTemplateItemVO[] | undefined;
}

export class WorkStationBriefInfo implements IWorkStationBriefInfo {
    workStationCode!: string | undefined;
    workStationId!: string | undefined;
    workStationName!: string | undefined;

    constructor(data?: IWorkStationBriefInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): WorkStationBriefInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationBriefInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IWorkStationBriefInfo {
    workStationCode: string | undefined;
    workStationId: string | undefined;
    workStationName: string | undefined;
}

export class WritePropertyValueDTO implements IWritePropertyValueDTO {
    /** 网关应用编号 */
    appCode!: number | undefined;
    /** 网关SN */
    gatewayCode!: string | undefined;
    propertyValueList!: IotPropertyValue[] | undefined;

    constructor(data?: IWritePropertyValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.gatewayCode = data["gatewayCode"];
            if (data["propertyValueList"] && data["propertyValueList"].constructor === Array) {
                this.propertyValueList = [] as any;
                for (let item of data["propertyValueList"])
                    this.propertyValueList!.push(IotPropertyValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WritePropertyValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WritePropertyValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["gatewayCode"] = this.gatewayCode;
        if (this.propertyValueList && this.propertyValueList.constructor === Array) {
            data["propertyValueList"] = [];
            for (let item of this.propertyValueList)
                data["propertyValueList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWritePropertyValueDTO {
    /** 网关应用编号 */
    appCode: number | undefined;
    /** 网关SN */
    gatewayCode: string | undefined;
    propertyValueList: IotPropertyValue[] | undefined;
}

export class WritePropertyValueResponseVO implements IWritePropertyValueResponseVO {
    /** 响应码 0成功|1失败 */
    code!: number | undefined;
    /** 错误信息 */
    errorMessage!: string | undefined;

    constructor(data?: IWritePropertyValueResponseVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): WritePropertyValueResponseVO {
        data = typeof data === 'object' ? data : {};
        let result = new WritePropertyValueResponseVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface IWritePropertyValueResponseVO {
    /** 响应码 0成功|1失败 */
    code: number | undefined;
    /** 错误信息 */
    errorMessage: string | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}